import { configFormData, configJson } from "./HelperMethod/utils";
import api from "./config/api";
import ApiIntercepter from "./HelperMethod/ApiIntercepter";
import SbomApiIntercepter from "./HelperMethod/SbomApiIntercepter";

async function send_otp(params) {
    return ApiIntercepter.post(api.SEND_OTP, params, configJson)
}
async function sign_up(params) {
    return ApiIntercepter.post(api.SIGN_UP, params, configJson)
}
async function sign_in(params) {
    return ApiIntercepter.post(api.SIGN_IN, params, configJson)
}
async function login_verify_otp(params) {
    return ApiIntercepter.post(api.LOGIN_VERIFY_OTP, params, configJson)
}
async function login_resend_otp(params) {
    return ApiIntercepter.post(api.LOGIN_RESEND_OTP, params, configJson)
}
async function forgot_password(params) {
    return ApiIntercepter.post(api.FORGOT_PASSWORD, params, configJson)
}
// Exchanges the one-time code from the SSO redirect for the same payload
// sign_in() returns. Tokens never travel in the URL, so this second call is
// what actually logs the user in.
async function sso_exchange_code(params) {
    return ApiIntercepter.post(api.SSO_EXCHANGE, params, configJson)
}
// Ends the provider's session as well as ours. Returns { logout_url }, which is
// null when there is no provider session to end — the caller then finishes the
// logout locally exactly as it always has.
async function sso_logout(params = {}) {
    return ApiIntercepter.post(api.SSO_LOGOUT, params, configJson)
}
// Answers whether an email domain federates, and returns the absolute URL to
// send the browser to. Safe to call for unknown addresses — the reply is the
// same for a real user and a made-up one at the same company.
async function sso_discover(email) {
    return ApiIntercepter.get(`${api.SSO_DISCOVER}?email=${encodeURIComponent(email)}`, configJson)
}

// SSO Authentication (super-admin) — domain + SAML connection provisioning.
async function get_sso_domains() {
    return ApiIntercepter.get(api.SSO_DOMAINS, configJson)
}

async function add_sso_domain(params) {
    return ApiIntercepter.post(api.SSO_DOMAINS, params, configJson)
}

// Accepts a domain without DNS proof — used for domains we own and for
// provider-owned ones (e.g. *.onmicrosoft.com) that cannot host a TXT record.
async function verify_sso_domain_manually(domain_id, params) {
    return ApiIntercepter.post(api.SSO_DOMAIN_MANUAL_VERIFY(domain_id), params, configJson)
}

async function get_sso_connections() {
    return ApiIntercepter.get(api.SSO_CONNECTIONS, configJson)
}

// Multipart: name, domains (repeatable) and the IdP federation metadata XML.
// The connection is always created disabled.
async function create_sso_connection(params) {
    return ApiIntercepter.post(api.SSO_CONNECTIONS, params, configFormData)
}

// Multipart: request_type (bug | feature), description, files (repeatable).
// The backend emails the request to the accountable support contact.
async function create_support_request(params) {
    return ApiIntercepter.post(api.SUPPORT_REQUEST, params, configFormData)
}

async function update_sso_connection(connection_id, params) {
    return ApiIntercepter.patch(api.SSO_CONNECTION_DETAIL(connection_id), params, configJson)
}
async function delete_sso_connection(connection_id) {
    return ApiIntercepter.delete(api.SSO_CONNECTION_DETAIL(connection_id), configJson)
}
async function verify_otp_reset(params) {
    return ApiIntercepter.post(api.VERIFY_OTP, params, configJson)
}
async function reset_password(params) {
    return ApiIntercepter.post(api.RESET_PASSWORD, params, configJson)
}
async function update_user_profile(params) {
    return ApiIntercepter.patch(api.USER_PROFILE_UPDATE, params, configJson)
}

async function getUserPlanInfoService() {
    return ApiIntercepter.get(api.USER_PLAN_INFO, configJson);
}

async function getUserProfileService() {
    return ApiIntercepter.get(api.USER_PROFILE, configJson);
}

async function getAuthMetadataService() {
    return ApiIntercepter.get(api.AUTH_METADATA, configJson);
}

// Dashbaord
async function scanner_domain_results(params) {
    return ApiIntercepter.get(api.SCANNER_DOMAIN_RESULTS, params, configJson)
}

async function scanner_scan_history_summary(params = {}) {
    const { analysis_date, organization_id } = params;
    const url = api.SCANNER_SCAN_HISTORY_SUMMARY({ analysis_date, organization_id });
    return ApiIntercepter.get(url);
}

async function scanner_scan_history(params = {}) {
    const { organization_id, start_date, end_date } = params;
    const url = api.SCANNER_SCAN_HISTORY({ organization_id, start_date, end_date });
    return ApiIntercepter.get(url);
}

async function scanner_scan_history_compare(params = {}) {
    const { organization_id, baseline_date, current_date } = params;
    const url = api.SCANNER_SCAN_HISTORY_COMPARE({ organization_id, baseline_date, current_date });
    return ApiIntercepter.get(url);
}

async function scanner_issue_details(params = {}) {
    const { finding_type, category, limit, offset, severity, severity_order, count_order } = params;
    const url = api.SCANNER_ISSUE_DETAILS({ finding_type, category, limit, offset, severity, severity_order, count_order });
    return ApiIntercepter.get(url);
}

async function download_evidence_csv(params, config = null) {
    const url = `${api.DOWNLOAD_EVIDENCE_CSV}?${params}`;
    const requestConfig = config || configJson;
    return ApiIntercepter.get(url, requestConfig)
}

async function findings_solution_details(params = {}) {
    const { category, finding } = params;
    const url = api.FINDINGS_SOLUTION_DETAILS({ category, finding });
    return ApiIntercepter.get(url);
}
async function category_finding(params) {
    return ApiIntercepter.get(api.CATEGORY_FINDINGS, params, configJson)
}

async function logout(params) {
    return ApiIntercepter.post(api.LOGOUT, params, configJson)
}

async function refreshToken(params) {
    return ApiIntercepter.post(api.REFRESH_TOKEN, params, configJson)
}
async function organization_domain(params) {
    return ApiIntercepter.get(api.ORGANIZATION_DOMAINS, params, configJson)
}
async function toggle_blacklist(params) {
    return ApiIntercepter.post(api.TOGGLE_BLACKLIST, params, configJson)
}
async function toggle_popup(params) {
    return ApiIntercepter.post(api.TOGGLE_POPUP, params, configJson)
}
async function domain_addition_request(params) {
    return ApiIntercepter.post(api.DOMAIN_ADDITION_REQUEST, params, configJson)
}
async function assest_management(params) {
    return ApiIntercepter.get(api.ASSEST_MANAGEMENT, params, configJson)
}
async function change_password(params) {
    return ApiIntercepter.post(api.CHANGE_PASSWORD, params, configJson)
}

// AI Chatbot
async function send_ai_query(params) {
    return ApiIntercepter.post(api.SEND_AI_QUERY, params, configJson)
}
async function chatbot_initialize(params) {
    return ApiIntercepter.post(api.CHATBOT_INITIALIZE, params, configJson)
}
async function delete_session(params) {
    return ApiIntercepter.delete(api.DELETE_SESSION, params, configJson)
}
async function add_on_service(params) {
    return ApiIntercepter.get(api.ADD_ON_SERVICE, params, configJson)
}

// Report Email Recipients
async function getReportEmailRecipients() {
    return ApiIntercepter.get(api.REPORT_EMAIL_RECIPIENTS, configJson);
}
async function addReportEmailRecipient(params) {
    return ApiIntercepter.post(api.REPORT_EMAIL_RECIPIENTS, params, configJson);
}
async function updateReportEmailRecipient(id, params) {
    return ApiIntercepter.patch(api.REPORT_EMAIL_RECIPIENT_BY_ID(id), params, configJson);
}
async function deleteReportEmailRecipient(id) {
    return ApiIntercepter.delete(api.REPORT_EMAIL_RECIPIENT_BY_ID(id), configJson);
}

// Org Members
async function getOrgMembers(organizationId) {
    const url = organizationId
        ? `${api.GET_ORG_MEMBERS}?organization_id=${organizationId}`
        : api.GET_ORG_MEMBERS;
    return ApiIntercepter.get(url, configJson);
}
async function addOrgMember(params, organizationId) {
    const url = organizationId
        ? `${api.ADD_ORG_MEMBER}?organization_id=${organizationId}`
        : api.ADD_ORG_MEMBER;
    return ApiIntercepter.post(url, params, configJson);
}
async function updateOrgMember(id, params, organizationId) {
    const base = api.UPDATE_ORG_MEMBER(id);
    const url = organizationId ? `${base}?organization_id=${organizationId}` : base;
    return ApiIntercepter.patch(url, params, configJson);
}
async function deleteOrgMember(id, organizationId) {
    const base = api.DELETE_ORG_MEMBER(id);
    const url = organizationId ? `${base}?organization_id=${organizationId}` : base;
    return ApiIntercepter.delete(url, configJson);
}

// Platform Users (super_admin only)
async function getPlatformUsers() {
    return ApiIntercepter.get(api.GET_PLATFORM_USERS, configJson);
}
async function addPlatformUser(params) {
    return ApiIntercepter.post(api.ADD_PLATFORM_USER, params, configJson);
}

// Role Assignments (super_admin only)
async function assignRoleToUser(params) {
    return ApiIntercepter.post(api.ASSIGN_ROLE, params, configJson);
}
async function unassignRoleFromUser(assignmentId) {
    return ApiIntercepter.delete(api.UNASSIGN_ROLE(assignmentId), configJson);
}

// Plan Management (super_admin only)
async function getPlans(activeOnly = false) {
    const url = activeOnly ? `${api.GET_PLANS}?active_only=true` : api.GET_PLANS;
    return ApiIntercepter.get(url, configJson);
}
async function createPlan(params) {
    return ApiIntercepter.post(api.CREATE_PLAN, params, configJson);
}
async function updatePlan(id, params) {
    return ApiIntercepter.put(api.UPDATE_PLAN(id), params, configJson);
}
async function deletePlan(id) {
    return ApiIntercepter.delete(api.DELETE_PLAN(id), configJson);
}

// Org Plan Allocation (super_admin only)
async function getOrgPlanAllocation(orgId) {
    return ApiIntercepter.get(api.GET_ORG_PLAN(orgId), configJson);
}
async function assignOrgPlan(orgId, params) {
    return ApiIntercepter.post(api.ASSIGN_ORG_PLAN(orgId), params, configJson);
}
async function addOrgTrialDays(orgId, params) {
    return ApiIntercepter.patch(api.ADD_TRIAL_DAYS(orgId), params, configJson);
}

// Available Permissions (super_admin only)
async function getAvailablePermissions() {
    return ApiIntercepter.get(api.GET_PERMISSIONS, configJson);
}

// Risk Registry

async function add_new_risk(params) {
    return ApiIntercepter.post(api.ADD_NEW_RISK_REGISTRY, params, configJson)
}
async function total_risk_created(params = {}) {
    const { start_date, end_date, ordering, limit, offset } = params;
    const url = api.TOTAL_RISK_CREATED({ start_date, end_date, ordering, limit, offset });
    return ApiIntercepter.get(url);
}
async function risk_by_stats(params = {}) {
    const { state, ordering, limit, offset } = params;
    const url = api.RISK_BY_STATS({ state, ordering, limit, offset });
    return ApiIntercepter.get(url);
}
async function risk_by_severity(params = {}) {
    const { severity, ordering, limit, offset } = params;
    const url = api.RISK_BY_SEVERITY({ severity, ordering, limit, offset });
    return ApiIntercepter.get(url);
}
async function risk_download(params = {}) {
    const start_date = params.params.start_date;
    const end_date = params.params.end_date;
    const url = api.DOWNLOAD_RISK_REGISTRY({ start_date, end_date });
    return ApiIntercepter.get(url);
}
async function bulk_upload_risk_registry(formData) {
    return ApiIntercepter.post(api.BULK_UPLOAD_RISK_REGISTRY, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    })
}
async function download_risk_registry_template(config = {}) {
    return ApiIntercepter.get(api.DOWNLOAD_RISK_REGISTRY_TEMPLATE, { ...configJson, ...config })
}
async function send_risk_notification(id) {
    return ApiIntercepter.post(api.SEND_RISK_NOTIFICATION(id), {}, configJson)
}
async function download_vendor_template() {
    return ApiIntercepter.get(api.DOWNLOAD_VENDOR_TEMPLATE, { responseType: 'arraybuffer' })
}
async function download_cxo_report(vendor_id) {
    return ApiIntercepter.get(api.DOWNLOAD_CXO_REPORT(vendor_id), { ...configJson, responseType: 'blob' })
}
async function list_all_risk(params) {
    return ApiIntercepter.get(api.LIST_ALL_RISK + params, configJson)
}
async function delete_risk(params = {}) {
    const { id } = params;
    const url = api.DELETE_RISK_REGISTRY({ id });
    return ApiIntercepter.delete(url);
}
async function get_by_id_risk(params = {}) {
    const { id } = params;
    const url = api.GET_BY_ID_RISK_REGISTRY({ id });
    return ApiIntercepter.get(url);
}
async function edit_by_id_risk_registry(params = {}) {
    const { id } = params;
    const url = api.EDIT_BY_ID_RISK_REGISTRY(id);
    return ApiIntercepter.patch(url, params.params);
}
// Full-record update (PUT) for the risk registry — used by the Edit Risk form.
async function update_risk_registry(params = {}) {
    const { id } = params;
    const url = api.EDIT_BY_ID_RISK_REGISTRY(id);
    return ApiIntercepter.put(url, params.params, configJson);
}

// Third party service

async function add_new_vendor_name(params) {
    return ApiIntercepter.post(api.ADD_NEW_VENDOR, params, configJson)
}
async function bulk_upload_vendors(formData) {
    return ApiIntercepter.post(api.BULK_UPLOAD_VENDORS, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    })
}
async function metaData(params) {
    return ApiIntercepter.get(api.META_DATA, params, configJson)
}
async function get_all_thirdparty_domain(params) {
    return ApiIntercepter.get(api.GET_ALL_THIRDPARTY_DOMAINS, params, configJson)
}
async function delete_by_id_thirdparty_domain(params) {
    const { id } = params;
    const url = api.DELETE_BY_ID_THIRDPARTY_DOMAIN({ id });
    return ApiIntercepter.delete(url);
}
async function get_by_id_third_party(params = {}) {
    const { id } = params;
    const url = api.GET_BY_ID_THIRD_PARTY({ id });
    return ApiIntercepter.get(url);
}
async function edit_by_id_third_party(params = {}) {
    const { id } = params;
    const url = api.EDIT_BY_ID_THIRD_PARTY(id);
    return ApiIntercepter.put(url, params.params);

}
async function vendors_by_business_impact_graph(params = {}) {
    const analysis_date = params.analysis_data
    const { start_date, end_date } = params;
    return ApiIntercepter.get(api.VENDORS_BY_BUSINESS_IMPACT_GRAPH({ analysis_date, start_date, end_date }), configJson)
}
async function vendors_positive_negative_trend(params = {}) {
    const analysis_date = params.analysis_data
    const { days_back, limit_negative, limit_positive } = params;
    const url = api.VENDORS_POSITIVE_NEGATIVE_TREND({ analysis_date, days_back, limit_negative, limit_positive });
    return ApiIntercepter.get(url);
}
async function third_party_download(params = {}) {
    const start_date = params.params.start_date;
    const url = api.DOWNLOAD_THIRD_PARTY({ start_date, });
    return ApiIntercepter.get(url);
}
async function third_party_monitored_vendors(params = {}) {
    const { search, ordering, analysis_date, start_date, end_date } = params;
    const url = api.THIRD_PARTY_MONITORED_VENDORS({ search, ordering, analysis_date, start_date, end_date });
    return ApiIntercepter.get(url);
}
async function vendors_with_incidents(params = {}) {
    const analysis_date = params.analysis_date;
    const url = api.VENDORS_WITH_INCIDENTS({ analysis_date });
    return ApiIntercepter.get(url)
}
async function vendors_with_critical_business_impact(params = {}) {
    const analysis_date = params.analysis_date;
    const url = api.VENDORS_WITH_CRITICAL_BUSINESS_IMPACT({ analysis_date })
    return ApiIntercepter.get(url)
}
async function show_vendors_details_data(params) {
    const target_organization_id = params.target_organization_id;
    const sort_by = params.sort_by
    return ApiIntercepter.get(api.SHOW_DETAIL_VENDORS_DATA({ target_organization_id, sort_by }), configJson)
}

async function send_invitation_to_vendor(params) {
    return ApiIntercepter.post(api.SEND_INVITATION_TO_VENDOR, params, configJson)
}

async function request_evidence_exception(params) {
    return ApiIntercepter.post(api.REQUEST_EVIDENCE_EXCEPTION, params, configFormData)
}
async function bulk_request_exception(params) {
    return ApiIntercepter.post(api.BULK_REQUEST_EXCEPTION, params, configFormData)
}
async function get_bank_list() {
    return ApiIntercepter.get(api.GET_BANK_LIST, configJson)
}
async function add_bank(params) {
    return ApiIntercepter.post(api.ADD_BANK, params, configJson)
}
async function invite_banks(params) {
    return ApiIntercepter.post(api.INVITE_BANKS, params, configJson)
}
async function bank_signup(params) {
    return ApiIntercepter.post(api.BANK_SIGNUP, params, configJson)
}
// Vulnerability Management Service
async function get_agents_vm_data(params) {
    return ApiIntercepter.get(api.GET_AGENTS_VM_DATA, params, configJson)
}
async function get_vulnerabilities_data(params) {
    return ApiIntercepter.get(api.GET_VULNERABILITIES_DATA, params, configJson)
}
async function show_vulnerabilities_details_data(params = {}) {
    const { search, severity, exploitability, flat, page_size } = params;
    const url = api.SHOW_DETAIL_VULNERABILITIES_DATA({ search, severity, exploitability, flat, page_size });
    return ApiIntercepter.get(url);
}
async function track_vm_graph_data(params = {}) {
    const { months_back } = params;
    const url = api.TRACK_VM_GRAPH_DATA({ months_back })
    return ApiIntercepter.get(url)
}
async function download_vm_excel_sheet(params) {
    return ApiIntercepter.get(api.DOWNLOAD_VM_EXCEL_FILE, params, configJson)
}

// website/user-region/
async function user_region(params) {
    return ApiIntercepter.get(api.USER_DATA, params, configJson)
}

// AI Governance Services
async function aig_dashboard() { return AIGApi.get(api.AIG_DASHBOARD, configJson) }
async function aig_scan(params) { return AIGApi.post(api.AIG_SCAN, params || {}, configJson) }
async function aig_assets(params) { return AIGApi.get(api.AIG_ASSETS, { ...configJson, params }) }
async function aig_shadow_assets() { return AIGApi.get(api.AIG_SHADOW_ASSETS, configJson) }
async function aig_approve_asset(id, params) { return AIGApi.post(api.AIG_APPROVE_ASSET(id), params || {}, configJson) }
async function aig_block_asset(id) { return AIGApi.post(api.AIG_BLOCK_ASSET(id), {}, configJson) }
async function aig_classify_asset(id, params) { return AIGApi.post(api.AIG_CLASSIFY_ASSET(id), params, configJson) }
async function aig_policies() { return AIGApi.get(api.AIG_POLICIES, configJson) }
async function aig_policy_create(params) { return AIGApi.post(api.AIG_POLICY_CREATE, params, configJson) }
async function aig_policy_init_defaults() { return AIGApi.post(api.AIG_POLICY_INIT_DEFAULTS, {}, configJson) }
async function aig_violations(params) { return AIGApi.get(api.AIG_VIOLATIONS, params, configJson) }
async function aig_signatures() { return AIGApi.get(api.AIG_SIGNATURES, configJson) }
async function aig_load_signatures() { return AIGApi.post(api.AIG_LOAD_SIGNATURES, {}, configJson) }
async function aig_trends(days) { return AIGApi.get(api.AIG_TRENDS(days), configJson) }
async function aig_trends_snapshot() { return AIGApi.post(api.AIG_TRENDS_SNAPSHOT, {}, configJson) }
async function aig_compliance_evaluate() { return AIGApi.post(api.AIG_COMPLIANCE_EVALUATE, {}, configJson) }
async function aig_compliance_scores() { return AIGApi.get(api.AIG_COMPLIANCE_SCORES, configJson) }
async function aig_assess_all() { return AIGApi.post(api.AIG_RISK_ASSESS_ALL, {}, configJson) }
async function aig_risk_scores() { return AIGApi.get(api.AIG_RISK_SCORES, configJson) }
async function aig_dlp_events(params) { return AIGApi.get(api.AIG_DLP_EVENTS, params, configJson) }
async function aig_dlp_summary(hours) { return AIGApi.get(api.AIG_DLP_SUMMARY(hours), configJson) }
async function aig_dlp_integrations() { return AIGApi.get(api.AIG_DLP_INTEGRATIONS, configJson) }
async function aig_dlp_create_integration(params) { return AIGApi.post(api.AIG_DLP_CREATE_INTEGRATION, params, configJson) }
async function aig_dlp_update_integration(id, params) { return AIGApi.post(api.AIG_DLP_UPDATE_INTEGRATION(id), params, configJson) }

// AI Governance — Whitelist & Exception Requests
async function aig_whitelist() { return AIGApi.get(api.AIG_WHITELIST, configJson) }
async function aig_whitelist_add(params) { return AIGApi.post(api.AIG_WHITELIST_ADD, params, configJson) }
async function aig_whitelist_remove(id) { return AIGApi.delete(api.AIG_WHITELIST_REMOVE(id), configJson) }
async function aig_exception_requests(params) { return AIGApi.get(api.AIG_EXCEPTION_REQUESTS, { ...configJson, params }) }
async function aig_exception_create(params) { return AIGApi.post(api.AIG_EXCEPTION_CREATE, params, configJson) }
async function aig_exception_review(id, params) { return AIGApi.post(api.AIG_EXCEPTION_REVIEW(id), params, configJson) }

// AI Governance — Enforce Block
async function aig_enforce_block(params) { return AIGApi.post(api.AIG_ENFORCE_BLOCK, params, configJson) }

// AI Governance — Enforcement Integrations
async function aig_enforcement_integrations() { return AIGApi.get(api.AIG_ENFORCEMENT_INTEGRATIONS, configJson) }
async function aig_enforcement_save(params) { return AIGApi.post(api.AIG_ENFORCEMENT_SAVE, params, configJson) }
async function aig_enforcement_delete(params) { return AIGApi.post(api.AIG_ENFORCEMENT_DELETE, params, configJson) }
async function aig_enforcement_test(params) { return AIGApi.post(api.AIG_ENFORCEMENT_TEST, params, configJson) }

// AI Governance — Identity Correlation
async function aig_user_profiles() { return AIGApi.get(api.AIG_USER_PROFILES, configJson) }

// AI Governance — Block List Export
async function aig_blocklist_export(format, scope) { return AIGApi.get(api.AIG_BLOCKLIST_EXPORT(format, scope), { ...configJson, responseType: 'text' }) }
async function aig_blocklist_formats() { return AIGApi.get(api.AIG_BLOCKLIST_FORMATS, configJson) }

// AI Governance — Audit & Schedules
async function aig_audit_log(params) { return AIGApi.get(api.AIG_AUDIT_LOG, { ...configJson, params }) }
async function aig_schedules() { return AIGApi.get(api.AIG_SCHEDULES, configJson) }
async function aig_schedule_create(params) { return AIGApi.post(api.AIG_SCHEDULE_CREATE, params, configJson) }
async function aig_schedule_toggle(id) { return AIGApi.post(api.AIG_SCHEDULE_TOGGLE(id), {}, configJson) }
async function aig_schedule_delete(id) { return AIGApi.delete(api.AIG_SCHEDULE_DELETE(id), configJson) }
async function aig_export_assets() { return AIGApi.get(api.AIG_EXPORT_ASSETS, configJson) }
async function aig_aibom_export(fmt) { return AIGApi.get(api.AIG_AIBOM_EXPORT(fmt), configJson) }

// Internal Audit Services
async function aig_audit_dashboard() { return AIGApi.get(api.AUDIT_DASHBOARD, configJson) }
async function aig_audit_my_tasks() { return AIGApi.get(api.AUDIT_MY_TASKS, configJson) }
async function aig_audit_frameworks() { return AIGApi.get(api.AUDIT_FRAMEWORKS, configJson) }
async function aig_audit_create_framework(params) { return AIGApi.post(api.AUDIT_CREATE_FRAMEWORK, params, configJson) }
async function aig_audit_delete_framework(id) { return AIGApi.delete(api.AUDIT_DELETE_FRAMEWORK(id), configJson) }
async function aig_audit_update_framework(id, params) { return AIGApi.put(api.AUDIT_UPDATE_FRAMEWORK(id), params, configJson) }
async function aig_audit_framework_controls(id) { return AIGApi.get(api.AUDIT_FRAMEWORK_CONTROLS(id), configJson) }
async function aig_audit_download_template() {
    const res = await AIGApi.get(api.AUDIT_DOWNLOAD_TEMPLATE, { responseType: 'arraybuffer' });
    return res?.data || res;
}
async function aig_audit_preview_headers(id, file) {
    const formData = new FormData();
    formData.append('file', file);
    return AIGApi.post(api.AUDIT_PREVIEW_HEADERS(id), formData, { headers: { 'Content-Type': 'multipart/form-data' } })
}
async function aig_audit_upload_controls(id, file, columnMapping) {
    const formData = new FormData();
    formData.append('file', file);
    if (columnMapping) formData.append('column_mapping', JSON.stringify(columnMapping));
    return AIGApi.post(api.AUDIT_UPLOAD_CONTROLS(id), formData, { headers: { 'Content-Type': 'multipart/form-data' } })
}
async function aig_audit_list(params) { return AIGApi.get(api.AUDIT_LIST, { ...configJson, params }) }
async function aig_audit_create(params) { return AIGApi.post(api.AUDIT_CREATE, params, configJson) }
async function aig_audit_detail(id) { return AIGApi.get(api.AUDIT_DETAIL(id), configJson) }
async function aig_audit_questions(id) { return AIGApi.get(api.AUDIT_QUESTIONS(id), configJson) }
async function aig_audit_auditee_progress(id) { return AIGApi.get(api.AUDIT_AUDITEE_PROGRESS(id), configJson) }
async function aig_audit_respond(auditId, controlId, params) { return AIGApi.post(api.AUDIT_RESPOND(auditId, controlId), params, configJson) }
async function aig_audit_review(auditId, controlId, params) { return AIGApi.post(api.AUDIT_REVIEW(auditId, controlId), params, configJson) }
async function aig_audit_review_bulk(auditId, params) { return AIGApi.post(api.AUDIT_REVIEW_BULK(auditId), params, configJson) }
async function aig_audit_findings(id) { return AIGApi.get(api.AUDIT_FINDINGS(id), configJson) }
async function aig_audit_create_finding(id, params) { return AIGApi.post(api.AUDIT_CREATE_FINDING(id), params, configJson) }
async function aig_audit_policies() { return AIGApi.get(api.AUDIT_POLICIES, configJson) }
async function aig_audit_create_policy(params) { return AIGApi.post(api.AUDIT_CREATE_POLICY, params, configJson) }
async function aig_audit_submit_policy(id, params) { return AIGApi.post(api.AUDIT_SUBMIT_POLICY(id), params, configJson) }
async function aig_audit_approve_policy(id, params) { return AIGApi.post(api.AUDIT_APPROVE_POLICY(id), params, configJson) }
async function aig_audit_generate_report(id, params) { return AIGApi.post(api.AUDIT_GENERATE_REPORT(id), params || {}, configJson) }
async function aig_audit_issue_aging() { return AIGApi.get(api.AUDIT_ISSUE_AGING, configJson) }
async function aig_audit_evidence_request(params) { return AIGApi.post(api.AUDIT_EVIDENCE_REQUEST, params, configJson) }
async function aig_audit_evidence_upload(params) {
    const formData = new FormData();
    Object.entries(params).forEach(([k, v]) => { if (v !== undefined && v !== null) formData.append(k, v); });
    return AIGApi.post(api.AUDIT_EVIDENCE_UPLOAD, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
}
async function aig_audit_evidence_download(id) { return AIGApi.get(api.AUDIT_EVIDENCE_DOWNLOAD(id), { responseType: 'blob' }) }
async function aig_audit_management_response(id, params) { return AIGApi.post(api.AUDIT_MANAGEMENT_RESPONSE(id), params, configJson) }
async function aig_audit_verify_finding(id, params) { return AIGApi.post(api.AUDIT_VERIFY_FINDING(id), params, configJson) }
async function aig_audit_universe() { return AIGApi.get(api.AUDIT_UNIVERSE, configJson) }
async function aig_audit_bulk_assess(id, params) { return AIGApi.post(api.AUDIT_BULK_ASSESS(id), params, configJson) }
async function aig_audit_submit_findings(id, params) { return AIGApi.post(api.AUDIT_SUBMIT_FINDINGS(id), params, configJson) }
async function aig_audit_notifications() { return AIGApi.get(api.AUDIT_NOTIFICATIONS, configJson) }
async function aig_audit_field_history(id, params) { return AIGApi.get(api.AUDIT_FIELD_HISTORY(id) + (params ? '?' + new URLSearchParams(params).toString() : ''), configJson) }
async function aig_audit_approval_status(id) { return AIGApi.get(api.AUDIT_APPROVAL_STATUS(id), configJson) }
async function aig_audit_approve_stage(id, params) { return AIGApi.post(api.AUDIT_APPROVE_STAGE(id), params, configJson) }
async function aig_audit_evidence_requests(id) { return AIGApi.get(api.AUDIT_EVIDENCE_REQUESTS(id), configJson) }
async function aig_audit_evidence_request_create(id, params) { return AIGApi.post(api.AUDIT_EVIDENCE_REQUEST_CREATE(id), params, configJson) }
async function aig_audit_evidence_request_submit(id) { return AIGApi.post(api.AUDIT_EVIDENCE_REQUEST_SUBMIT(id), {}, configJson) }
async function aig_audit_evidence_request_review(id, params) { return AIGApi.post(api.AUDIT_EVIDENCE_REQUEST_REVIEW(id), params, configJson) }

// Audit — Business Units
async function aig_audit_business_units(params) { return AIGApi.get(api.AUDIT_BU_LIST + (params ? '?' + new URLSearchParams(params).toString() : ''), configJson) }
async function aig_audit_create_business_unit(params) { return AIGApi.post(api.AUDIT_BU_CREATE, params, configJson) }
async function aig_audit_update_business_unit(id, params) { return AIGApi.put(api.AUDIT_BU_UPDATE(id), params, configJson) }

// Audit — Projects
async function aig_audit_projects(params) { return AIGApi.get(api.AUDIT_PROJECTS + (params ? '?' + new URLSearchParams(params).toString() : ''), configJson) }
async function aig_audit_create_project(params) { return AIGApi.post(api.AUDIT_PROJECT_CREATE, params, configJson) }
async function aig_audit_update_project(id, params) { return AIGApi.put(api.AUDIT_PROJECT_UPDATE(id), params, configJson) }
async function aig_audit_delete_project(id) { return AIGApi.delete(api.AUDIT_PROJECT_DELETE(id), configJson) }

// Audit Portal Auth
async function aig_portal_invite(params) { return AIGApi.post(api.AUDIT_PORTAL_INVITE, params, configJson) }
async function aig_portal_register(params) {
    // No auth needed - public endpoint
    const axios = (await import('axios')).default;
    const res = await axios.post(api.AUDIT_PORTAL_REGISTER, params, { headers: { 'Content-Type': 'application/json' } });
    return res.data;
}
async function aig_portal_login(params) {
    // No auth needed - public endpoint
    const axios = (await import('axios')).default;
    const res = await axios.post(api.AUDIT_PORTAL_LOGIN, params, { headers: { 'Content-Type': 'application/json' } });
    return res.data;
}
async function aig_portal_users() { return AIGApi.get(api.AUDIT_PORTAL_USERS, configJson) }
// Audit-portal role for a caller who signed in through their identity provider.
async function aig_portal_session() { return AIGApi.get(api.AUDIT_PORTAL_SESSION, configJson) }
async function aig_portal_user_update(id, params) { return AIGApi.put(api.AUDIT_PORTAL_USER_UPDATE(id), params, configJson) }
async function aig_portal_user_delete(id) { return AIGApi.delete(api.AUDIT_PORTAL_USER_DELETE(id), configJson) }
async function aig_audit_user_modules() { return AIGApi.get(api.AUDIT_USER_MODULES, configJson) }
async function aig_portal_ad_sync() { return AIGApi.post(api.AUDIT_PORTAL_AD_SYNC, {}, configJson) }
async function aig_portal_ad_config(params) { return AIGApi.post(api.AUDIT_PORTAL_AD_CONFIG, params, configJson) }
async function aig_workflow_config(params) { return AIGApi.get(api.AUDIT_WORKFLOW_CONFIG + (params?.id ? `?id=${params.id}` : ''), configJson) }
async function aig_workflow_config_update(params) { return AIGApi.put(api.AUDIT_WORKFLOW_CONFIG_UPDATE, params, configJson) }
async function aig_workflow_config_reset() { return AIGApi.post(api.AUDIT_WORKFLOW_CONFIG_RESET, {}, configJson) }
async function aig_workflow_config_apply_template(params) { return AIGApi.post(api.AUDIT_WORKFLOW_CONFIG_APPLY_TEMPLATE, params, configJson) }

// Audit — Users
async function aig_audit_users() { return AIGApi.get(api.AUDIT_USERS, configJson) }
async function aig_audit_invite_user(params) { return AIGApi.post(api.AUDIT_INVITE_USER, params, configJson) }
async function aig_audit_update_user(id, params) { return AIGApi.put(api.AUDIT_UPDATE_USER(id), params, configJson) }
async function aig_audit_deactivate_user(id) { return AIGApi.delete(api.AUDIT_DEACTIVATE_USER(id), configJson) }

// Audit Admin — Custom Fields
async function aig_audit_custom_fields(params) { return AIGApi.get(api.AUDIT_CUSTOM_FIELDS + (params ? '?' + new URLSearchParams(params).toString() : ''), configJson) }
async function aig_audit_custom_field_create(params) { return AIGApi.post(api.AUDIT_CUSTOM_FIELD_CREATE, params, configJson) }
async function aig_audit_custom_field_update(id, params) { return AIGApi.put(api.AUDIT_CUSTOM_FIELD_UPDATE(id), params, configJson) }
async function aig_audit_custom_field_delete(id) { return AIGApi.delete(api.AUDIT_CUSTOM_FIELD_DELETE(id), configJson) }
async function aig_audit_custom_field_reorder(params) { return AIGApi.post(api.AUDIT_CUSTOM_FIELD_REORDER, params, configJson) }
async function aig_audit_custom_field_save_values(params) { return AIGApi.post(api.AUDIT_CUSTOM_FIELD_SAVE_VALUES, params, configJson) }
async function aig_audit_custom_field_values(params) { return AIGApi.get(api.AUDIT_CUSTOM_FIELD_VALUES + '?' + new URLSearchParams(params).toString(), configJson) }

// Audit Admin — Workflow CRUD
async function aig_audit_workflows() { return AIGApi.get(api.AUDIT_WORKFLOWS, configJson) }
async function aig_audit_create_workflow(params) { return AIGApi.post(api.AUDIT_CREATE_WORKFLOW, params, configJson) }
async function aig_audit_update_workflow(id, params) { return AIGApi.put(api.AUDIT_UPDATE_WORKFLOW(id), params, configJson) }
async function aig_audit_delete_workflow(id) { return AIGApi.delete(api.AUDIT_DELETE_WORKFLOW(id), configJson) }

// Audit Admin — Org Config
async function aig_audit_config() { return AIGApi.get(api.AUDIT_CONFIG, configJson) }
async function aig_audit_config_update(params) { return AIGApi.put(api.AUDIT_CONFIG_UPDATE, params, configJson) }

// Audit Lifecycle (#1-6, #15-17)
async function aig_audit_update(id, params) { return AIGApi.put(api.AUDIT_UPDATE(id), params, configJson) }
async function aig_audit_assign(id, params) { return AIGApi.post(api.AUDIT_ASSIGN(id), params, configJson) }
async function aig_audit_advance_stage(id, params) { return AIGApi.post(api.AUDIT_ADVANCE_STAGE(id), params, configJson) }
async function aig_audit_progress(id) { return AIGApi.get(api.AUDIT_PROGRESS(id), configJson) }
async function aig_audit_timeline(id) { return AIGApi.get(api.AUDIT_TIMELINE(id), configJson) }
async function aig_audit_close(id, params) { return AIGApi.post(api.AUDIT_CLOSE(id), params || {}, configJson) }
async function aig_audit_delete(id) { return AIGApi.delete(api.AUDIT_DELETE(id), configJson) }
async function aig_audit_complete(id, params) { return AIGApi.post(api.AUDIT_COMPLETE(id), params, configJson) }
async function aig_audit_sign_off(id, params) { return AIGApi.post(api.AUDIT_SIGN_OFF(id), params, configJson) }
async function aig_audit_bulk_assign_questions(id, params) { return AIGApi.post(api.AUDIT_BULK_ASSIGN_QUESTIONS(id), params, configJson) }
async function aig_audit_assign_controls(payload) { return AIGApi.post(api.AUDIT_ASSIGN_CONTROLS, payload, configJson) }
async function aig_audit_export_responses(id) { return AIGApi.get(api.AUDIT_EXPORT_RESPONSES(id), { responseType: 'blob' }) }

// Finding Lifecycle (#7-9)
async function aig_audit_update_finding(id, params) { return AIGApi.put(api.AUDIT_UPDATE_FINDING(id), params, configJson) }
async function aig_audit_remediate_finding(id, params) { return AIGApi.post(api.AUDIT_REMEDIATE_FINDING(id), params, configJson) }
async function aig_audit_accept_risk(id, params) { return AIGApi.post(api.AUDIT_ACCEPT_RISK(id), params, configJson) }
async function aig_audit_create_risk_from_finding(id, params) { return AIGApi.post(api.AUDIT_CREATE_RISK_FROM_FINDING(id), params || {}, configJson) }

// Evidence (#11)
async function aig_audit_delete_evidence(id) { return AIGApi.delete(api.AUDIT_DELETE_EVIDENCE(id), configJson) }

// Policy Lifecycle (#10, #12-14)
async function aig_audit_update_policy(id, params) { return AIGApi.put(api.AUDIT_UPDATE_POLICY(id), params, configJson) }
async function aig_audit_policy_versions(id) { return AIGApi.get(api.AUDIT_POLICY_VERSIONS(id), configJson) }
async function aig_audit_policy_acknowledge(id) { return AIGApi.post(api.AUDIT_POLICY_ACKNOWLEDGE(id), {}, configJson) }
async function aig_audit_policy_ack_status(id) { return AIGApi.get(api.AUDIT_POLICY_ACK_STATUS(id), configJson) }

// Internal Audit Enhancements
async function aig_audit_clone(id, params) { return AIGApi.post(api.AUDIT_CLONE(id), params, configJson) }
async function aig_audit_linked(id) { return AIGApi.get(api.AUDIT_LINKED(id), configJson) }
async function aig_audit_recurring_schedules() { return AIGApi.get(api.AUDIT_RECURRING_SCHEDULES, configJson) }
async function aig_audit_create_recurring_schedule(params) { return AIGApi.post(api.AUDIT_RECURRING_SCHEDULES, params, configJson) }
async function aig_audit_update_recurring_schedule(id, params) { return AIGApi.put(api.AUDIT_RECURRING_SCHEDULE_DETAIL(id), params, configJson) }
async function aig_audit_delete_recurring_schedule(id) { return AIGApi.delete(api.AUDIT_RECURRING_SCHEDULE_DETAIL(id), configJson) }
async function aig_audit_scope_tree(frameworkId) { return AIGApi.get(api.AUDIT_SCOPE_TREE(frameworkId), configJson) }
async function aig_audit_update_scope(id, params) { return AIGApi.put(api.AUDIT_UPDATE_SCOPE(id), params, configJson) }
async function aig_audit_add_framework(id, params) { return AIGApi.post(api.AUDIT_ADD_FRAMEWORK(id), params, configJson) }
async function aig_audit_multi_frameworks(id) { return AIGApi.get(api.AUDIT_MULTI_FRAMEWORKS(id), configJson) }
async function aig_audit_compare(id, prevId) { return AIGApi.get(api.AUDIT_COMPARE(id, prevId), configJson) }
async function aig_audit_capas(params) { return AIGApi.get(api.AUDIT_CAPAS + (params ? '?' + new URLSearchParams(params).toString() : ''), configJson) }
async function aig_audit_create_capa(params) { return AIGApi.post(api.AUDIT_CAPAS, params, configJson) }
async function aig_audit_update_capa(id, params) { return AIGApi.put(api.AUDIT_CAPA_UPDATE(id), params, configJson) }
async function aig_audit_delete_capa(id) { return AIGApi.delete(api.AUDIT_CAPA_DELETE(id), configJson) }
async function aig_audit_capa_history(id) { return AIGApi.get(api.AUDIT_CAPA_HISTORY(id), configJson) }
async function aig_audit_bulk_update_capas(params) { return AIGApi.post(api.AUDIT_CAPA_BULK_UPDATE, params, configJson) }
async function aig_audit_capa_export(params) { return AIGApi.get(api.AUDIT_CAPA_EXPORT + (params ? '?' + new URLSearchParams(params).toString() : ''), { responseType: 'blob' }) }
async function aig_audit_management_summary() { return AIGApi.get(api.AUDIT_MANAGEMENT_SUMMARY, configJson) }
async function aig_audit_evidence_library(params) { return AIGApi.get(api.AUDIT_EVIDENCE_LIBRARY + (params ? '?' + new URLSearchParams(params).toString() : ''), configJson) }
async function aig_audit_evidence_library_filters() { return AIGApi.get(api.AUDIT_EVIDENCE_LIBRARY_FILTERS, configJson) }
async function aig_audit_evidence_library_export(params) { return AIGApi.get(api.AUDIT_EVIDENCE_LIBRARY_EXPORT + (params ? '?' + new URLSearchParams(params).toString() : ''), { responseType: 'blob' }) }
async function aig_audit_evidence_library_audits(params) { return AIGApi.get(api.AUDIT_EVIDENCE_LIBRARY_AUDITS + (params ? '?' + new URLSearchParams(params).toString() : ''), configJson) }
async function aig_audit_evidence_library_breakdown(id, params) { return AIGApi.get(api.AUDIT_EVIDENCE_LIBRARY_BREAKDOWN(id) + (params ? '?' + new URLSearchParams(params).toString() : ''), configJson) }
async function aig_audit_check_recurring_finding(auditId, controlId) { return AIGApi.get(api.AUDIT_CHECK_RECURRING_FINDING(auditId, controlId), configJson) }
async function aig_audit_set_scoring_model(id, params) { return AIGApi.put(api.AUDIT_SCORING_MODEL(id), params, configJson) }
async function aig_audit_set_maturity_score(auditId, controlId, params) { return AIGApi.post(api.AUDIT_MATURITY_SCORE(auditId, controlId), params, configJson) }
async function aig_audit_calendar(params) { return AIGApi.get(api.AUDIT_CALENDAR + (params ? '?' + new URLSearchParams(params).toString() : ''), configJson) }
async function aig_audit_create_calendar_entry(params) { return AIGApi.post(api.AUDIT_CALENDAR, params, configJson) }
async function aig_audit_update_calendar_entry(id, params) { return AIGApi.put(api.AUDIT_CALENDAR_ENTRY(id), params, configJson) }
async function aig_audit_delete_calendar_entry(id) { return AIGApi.delete(api.AUDIT_CALENDAR_ENTRY(id), configJson) }
async function aig_audit_convert_calendar_entry(id, params) { return AIGApi.post(api.AUDIT_CALENDAR_CONVERT(id), params || {}, configJson) }
async function aig_audit_export_calendar(params) { return AIGApi.get(api.AUDIT_CALENDAR_EXPORT + (params ? '?' + new URLSearchParams(params).toString() : ''), { responseType: 'blob' }) }
async function kri_get_upload_checklist(id) { return AIGApi.get(api.KRI_UPLOAD_CHECKLIST(id), configJson) }
// KRI Matrix
async function user_modules() { return AIGApi.get(api.USER_MODULES, configJson) }

// KPI Importer
async function kpi_preview(file) {
    const fd = new FormData(); fd.append('file', file);
    return AIGApi.post(api.KPI_PREVIEW, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
}
async function kpi_import(file, options) {
    const fd = new FormData(); fd.append('file', file); fd.append('options', JSON.stringify(options || {}));
    return AIGApi.post(api.KPI_IMPORT, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
}

async function kpi_acknowledge(id) { return AIGApi.post(api.KPI_ACKNOWLEDGE(id), {}, configJson) }
async function kpi_my_kpis() { return AIGApi.get(api.KPI_MY_KPIS, configJson) }
async function kpi_template() { return AIGApi.get(api.KPI_TEMPLATE, { responseType: 'blob' }) }
async function kpi_update(id, params) { return AIGApi.post(api.KPI_UPDATE(id), params, configJson) }
// KPI CRUD (new model)
async function kpis_list(params) { return AIGApi.get(api.KPIS_LIST + (params ? '?' + new URLSearchParams(params).toString() : ''), configJson) }
async function kpis_create(params) { return AIGApi.post(api.KPIS_CREATE, params, configJson) }
async function kpis_update(id, params) { return AIGApi.put(api.KPIS_UPDATE(id), params, configJson) }
async function kpis_delete(id) { return AIGApi.delete(api.KPIS_DELETE(id), configJson) }
async function kpis_acknowledge(id) { return AIGApi.post(api.KPIS_ACKNOWLEDGE(id), {}, configJson) }
async function kpis_evidence(id, file) { const fd = new FormData(); fd.append('file', file); return AIGApi.post(api.KPIS_EVIDENCE(id), fd, { headers: { 'Content-Type': 'multipart/form-data' } }) }
async function kpis_history(id, bust) { return AIGApi.get(api.KPIS_HISTORY(id) + (bust ? (api.KPIS_HISTORY(id).includes('?') ? '&' : '?') + '_=' + bust : ''), configJson) }
async function kpis_bulk_update(updates) { return AIGApi.post(api.KPIS_BULK_UPDATE, { updates }, configJson) }
async function kpi_upload_evidence(id, file, description) {
    const fd = new FormData(); fd.append('file', file); if (description) fd.append('description', description);
    return AIGApi.post(api.KPI_UPLOAD_EVIDENCE(id), fd, { headers: { 'Content-Type': 'multipart/form-data' } })
}
async function kpi_library() { return AIGApi.get(api.KPI_LIBRARY, configJson) }
async function kpi_library_import(params) { return AIGApi.post(api.KPI_LIBRARY_IMPORT, params, configJson) }
async function kpi_snapshot(params) { return AIGApi.post(api.KPI_SNAPSHOT, params, configJson) }
async function kpi_trends(params) { return AIGApi.get(api.KPI_TRENDS + (params ? '?' + new URLSearchParams(params).toString() : ''), configJson) }
async function kpis_purge(id, confirm_name) { return AIGApi.post(api.KPIS_PURGE(id), { confirm_name }, configJson) }
async function kpis_bulk_archive(kpi_ids, archive_name = '') { return AIGApi.post(api.KPIS_BULK_ARCHIVE, { kpi_ids, archive_name }, configJson) }
async function kpis_archive_batches() { return AIGApi.get(api.KPIS_ARCHIVE_BATCHES + '?_=' + Date.now(), configJson) }
async function kpis_bulk_purge(kpi_ids, confirm_count) { return AIGApi.post(api.KPIS_BULK_PURGE, { kpi_ids, confirm_count }, configJson) }
async function kpis_updates_list(id) { return AIGApi.get(api.KPIS_UPDATES(id), configJson) }
async function kpis_updates_create(id, text) { return AIGApi.post(api.KPIS_UPDATES(id), { text }, configJson) }
async function kpi_admins_list() { return AIGApi.get(api.KPI_ADMINS_LIST, configJson) }
async function kpi_admins_revoke(email, demote_to) { return AIGApi.post(api.KPI_ADMINS_REVOKE(email), { demote_to }, configJson) }
async function kpi_org_config_get() { return AIGApi.get(api.KPI_ORG_CONFIG, configJson) }
async function kpi_org_config_update(params) { return AIGApi.put(api.KPI_ORG_CONFIG, params, configJson) }
async function kpis_assign_owner(id, params) { return AIGApi.post(api.KPIS_ASSIGN_OWNER(id), params, configJson) }
async function kpis_bulk_assign(params) { return AIGApi.post(api.KPIS_BULK_ASSIGN, params, configJson) }
async function kpis_escalations(params) { return AIGApi.get(api.KPIS_ESCALATIONS + (params ? '?' + new URLSearchParams(params).toString() : ''), configJson) }
async function kpis_escalations_send(kpi_ids) { return AIGApi.get(api.KPIS_ESCALATIONS + (kpi_ids?.length ? '?' + new URLSearchParams({ kpi_ids: kpi_ids.join(',') }).toString() : ''), configJson) }
async function kpis_escalate(kpi_ids) { return AIGApi.post(api.KPIS_ESCALATE, { kpi_ids }, configJson) }
async function kpis_export(params) { return AIGApi.get(api.KPIS_EXPORT + (params ? '?' + new URLSearchParams(params).toString() : ''), { responseType: 'blob' }) }
async function kpis_dedupe(dry_run) { return AIGApi.post(api.KPIS_DEDUPE, { dry_run: !!dry_run }, configJson) }
async function kpis_restore(id) { return AIGApi.post(api.KPIS_RESTORE(id), {}, configJson) }
async function kpis_ai_summarise_quarter(params) { return AIGApi.post(api.KPIS_AI_SUMMARISE_QUARTER, params || {}, configJson) }
async function kpis_ai_explain_gap(id) { return AIGApi.post(api.KPIS_AI_EXPLAIN_GAP(id), {}, configJson) }
async function kpis_evidence_list(kpiId) { return AIGApi.get(api.KPIS_EVIDENCE_LIST(kpiId), configJson) }
async function kpis_evidence_delete(kpiId, evId) { return AIGApi.delete(api.KPIS_EVIDENCE_DELETE(kpiId, evId), configJson) }
async function kpis_evidence_download(kpiId, evId) { return AIGApi.get(api.KPIS_EVIDENCE_DOWNLOAD(kpiId, evId), { responseType: 'blob' }) }

async function kri_dashboard() { return AIGApi.get(api.KRI_DASHBOARD, configJson) }
async function kri_tools() { return AIGApi.get(api.KRI_TOOLS, configJson) }
async function kri_vendors() { return AIGApi.get(api.KRI_VENDORS, configJson) }
async function kri_create_tool(params) { return AIGApi.post(api.KRI_TOOL_CREATE, params, configJson) }
async function kri_update_tool(id, params) { return AIGApi.put(api.KRI_TOOL_UPDATE(id), params, configJson) }
async function kri_delete_tool(id) { return AIGApi.delete(api.KRI_TOOL_DELETE(id), configJson) }
async function kri_test_tool(id) { return AIGApi.post(api.KRI_TOOL_TEST(id), {}, configJson) }
async function kri_preview_tool(params) { return AIGApi.post(api.KRI_TOOL_PREVIEW, params, configJson) }
async function kri_preview_tool_status(taskId) { return AIGApi.get(api.KRI_TOOL_PREVIEW_STATUS + '?task_id=' + taskId, configJson) }
async function kri_sync_tool(id, params) { return AIGApi.post(api.KRI_TOOL_SYNC(id), params || {}, configJson) }
async function kri_upload_tool_devices(id, file) {
    const fd = new FormData(); fd.append('file', file);
    return AIGApi.post(api.KRI_TOOL_UPLOAD_DEVICES(id), fd, { headers: { 'Content-Type': 'multipart/form-data' } })
}
async function kri_assets(params) { return AIGApi.get(api.KRI_ASSETS + (params ? '?' + new URLSearchParams(params).toString() : ''), configJson) }
async function kri_create_asset(params) { return AIGApi.post(api.KRI_ASSET_CREATE, params, configJson) }
async function kri_upload_assets(file) {
    const fd = new FormData(); fd.append('file', file);
    return AIGApi.post(api.KRI_ASSET_UPLOAD, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
}
async function kri_delete_asset(id) { return AIGApi.delete(api.KRI_ASSET_DELETE(id), configJson) }
async function kri_matrix(params) { return AIGApi.get(api.KRI_MATRIX + (params ? '?' + new URLSearchParams(params).toString() : ''), configJson) }
async function kri_gaps(params) { return AIGApi.get(api.KRI_GAPS + (params ? '?' + new URLSearchParams(params).toString() : ''), configJson) }
async function kri_remediate_gap(id, params) { return AIGApi.put(api.KRI_GAP_REMEDIATE(id), params, configJson) }
async function kri_sync_logs(params) { return AIGApi.get(api.KRI_SYNC_LOGS + (params ? '?' + new URLSearchParams(params).toString() : ''), configJson) }
async function kri_export_gaps(params) { return AIGApi.get(api.KRI_GAPS_EXPORT + (params ? '?' + new URLSearchParams(params).toString() : ''), { responseType: 'blob' }) }
async function kri_connector_discover(params) { return AIGApi.post(api.KRI_CONNECTOR_DISCOVER, params, configJson) }
async function kri_connector_ai_map(params) { return AIGApi.post(api.KRI_CONNECTOR_AI_MAP, params, configJson) }
// async function kri_get_upload_checklist(id) { return AIGApi.get(api.KRI_UPLOAD_CHECKLIST(id), configJson) }
async function kri_get_sync_status(id) { return AIGApi.get(api.KRI_TOOL_SYNC_STATUS(id), configJson) }
async function kri_reprocess_tool(id) { return AIGApi.post(api.KRI_TOOL_REPROCESS(id), {}, configJson) }
async function kri_list_unmatched_tool_assets(id) { return AIGApi.get(api.KRI_TOOL_UNMATCHED(id), configJson) }
async function kri_add_unmatched_to_baseline(toolId, assetId) { return AIGApi.post(api.KRI_TOOL_UNMATCHED_ADD(toolId, assetId), {}, configJson) }
async function kri_dismiss_unmatched_tool_asset(toolId, assetId) { return AIGApi.post(api.KRI_TOOL_UNMATCHED_DISMISS(toolId, assetId), {}, configJson) }
async function kri_list_definitions(params) { return AIGApi.get(api.KRI_DEFINITIONS + (params ? '?' + new URLSearchParams(params).toString() : ''), configJson) }
async function kri_create_definition(params) { return AIGApi.post(api.KRI_DEFINITIONS, params, configJson) }
async function kri_update_definition(id, params) { return AIGApi.put(api.KRI_DEFINITION_UPDATE(id), params, configJson) }
async function kri_delete_definition(id) { return AIGApi.delete(api.KRI_DEFINITION_DELETE(id), configJson) }
async function kri_permanent_delete_definition(id) { return AIGApi.delete(api.KRI_DEFINITION_UPDATE(id) + '?permanent=1', configJson) }
async function kri_download_definition_template() { return AIGApi.get(api.KRI_DEFINITION_TEMPLATE, { responseType: 'blob' }) }
async function kri_import_definitions_preview(file) {
    const fd = new FormData(); fd.append('file', file);
    return AIGApi.post(api.KRI_DEFINITION_IMPORT_PREVIEW, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
}
async function kri_import_definitions_commit(params) { return AIGApi.post(api.KRI_DEFINITION_IMPORT_COMMIT, params, configJson) }
async function kri_request_baseline_recommendation(id) { return AIGApi.post(api.KRI_AI_BASELINE_REC(id), {}, configJson) }
async function kri_apply_baseline_to_tool(id, params) { return AIGApi.post(api.KRI_AI_APPLY_BASELINE(id), params, configJson) }
async function kri_ai_auto_configure_from_preview(params) { return AIGApi.post(api.KRI_AI_AUTO_CONFIGURE, params, configJson) }
async function kri_ai_diagnose_connection_failure(params) { return AIGApi.post(api.KRI_AI_DIAGNOSE, params, configJson) }
async function kri_ai_suggest_adapter(params) { return AIGApi.post(api.KRI_AI_SUGGEST_ADAPTER, params, configJson) }
async function kri_ai_explain_upload(id) { return AIGApi.post(api.KRI_AI_EXPLAIN_UPLOAD(id), {}, configJson) }
async function kri_ai_suggest_dashboard_labels(id) { return AIGApi.post(api.KRI_AI_SUGGEST_LABELS(id), {}, configJson) }
async function kri_ai_summarise_dashboard() { return AIGApi.post(api.KRI_AI_SUMMARISE, {}, configJson) }
async function kri_ai_analyze_coverage() { return AIGApi.get(api.KRI_AI_COVERAGE, configJson) }
async function kri_ai_analyze_gaps(params) { return AIGApi.get(api.KRI_AI_GAPS + (params ? '?' + new URLSearchParams(params).toString() : ''), configJson) }
async function kri_ai_audit_baseline() { return AIGApi.post(api.KRI_AI_BASELINE_AUDIT, {}, configJson) }
async function kri_ai_suggest_api_url(params) { return AIGApi.post(api.KRI_AI_SUGGEST_URL, params, configJson) }
async function kri_get_tool_usage_metrics(id) { return AIGApi.get(api.KRI_TOOL_USAGE(id), configJson) }
async function kri_get_tool_drift_history(id) { return AIGApi.get(api.KRI_TOOL_DRIFT(id), configJson) }
async function kri_get_baseline_policies(id) { return AIGApi.get(api.KRI_BASELINE_POLICIES(id), configJson) }

// Aliases used by KRIMatrix.js
const kri_list_tools = kri_tools;
const kri_list_vendors = kri_vendors;
const kri_list_gaps = kri_gaps;
const kri_list_assets = kri_assets;
const kri_list_sync_logs = kri_sync_logs;
const kri_mark_gap_remediated = kri_remediate_gap;
async function kri_get_dashboard(params) { return AIGApi.get(api.KRI_DASHBOARD + (params ? '?' + new URLSearchParams(params).toString() : ''), configJson) }
const kri_get_compliance_matrix = kri_matrix;
const kri_test_tool_connection = kri_test_tool;
const kri_preview_tool_data = kri_preview_tool;
const kri_universal_discover_fields = kri_connector_discover;
const kri_ai_map_universal_fields = kri_connector_ai_map;
const kri_export_gap_report = kri_export_gaps;

async function kri_cancel_sync(id) { return AIGApi.post(api.KRI_TOOL_CANCEL_SYNC(id), {}, configJson) }
async function kri_get_org_settings() { return AIGApi.get(api.KRI_ORG_SETTINGS, configJson) }
async function kri_update_org_settings(params) { return AIGApi.put(api.KRI_ORG_SETTINGS, params, configJson) }
async function kri_list_mapping_rules() { return AIGApi.get(api.KRI_MAPPING_RULES, configJson) }
async function kri_create_mapping_rule(params) { return AIGApi.post(api.KRI_MAPPING_RULES, params, configJson) }
async function kri_update_mapping_rule(id, params) { return AIGApi.put(api.KRI_MAPPING_RULE(id), params, configJson) }
async function kri_delete_mapping_rule(id) { return AIGApi.delete(api.KRI_MAPPING_RULE(id), configJson) }
async function kri_apply_mapping_rule(id, opts) { return AIGApi.post(api.KRI_MAPPING_RULE_APPLY(id), opts || {}, configJson) }
async function kri_save_snapshot() { return AIGApi.post(api.KRI_SAVE_SNAPSHOT, {}, configJson) }
async function kri_set_tool_rollout_grace(id, params) { return AIGApi.post(api.KRI_TOOL_ROLLOUT_GRACE(id), params || {}, configJson) }
async function kri_get_tool_audit_log(id) { return AIGApi.get(api.KRI_TOOL_AUDIT_LOG(id), configJson) }

// Endpoint / Wazuh Config
async function sbom_wazuh_config_get() { return SbomApi.get(api.SBOM_WAZUH_CONFIG_GET, configJson) }
async function sbom_wazuh_config_save(params) { return SbomApi.post(api.SBOM_WAZUH_CONFIG_SAVE, params, configJson) }
async function sbom_wazuh_config_test() { return SbomApi.post(api.SBOM_WAZUH_CONFIG_TEST, {}, configJson) }
async function sbom_wazuh_config_disable() { return SbomApi.post(api.SBOM_WAZUH_CONFIG_DISABLE, {}, configJson) }
async function sbom_wazuh_config_delete() { return SbomApi.delete(api.SBOM_WAZUH_CONFIG_DELETE, configJson) }

// Ops Search
async function ops_search(query, type) { return SbomApi.get(api.OPS_SEARCH(query, type), configJson) }
async function ops_assets(params) { return SbomApi.get(api.OPS_ASSETS, params, configJson) }

// Trust Center Services
async function tc_get_config() { return TrustCenterApi.get(api.TC_CONFIG, configJson) }
async function tc_setup(params) { return TrustCenterApi.post(api.TC_SETUP, params, configJson) }
async function tc_publish() { return TrustCenterApi.post(api.TC_PUBLISH, {}, configJson) }
async function tc_list_pages() { return TrustCenterApi.get(api.TC_PAGES, configJson) }
async function tc_update_page(id, params) { return TrustCenterApi.post(api.TC_PAGE_UPDATE(id), params, configJson) }
async function tc_list_certifications() { return TrustCenterApi.get(api.TC_CERTIFICATIONS, configJson) }
async function tc_create_certification(params) { return TrustCenterApi.post(api.TC_CERTIFICATION_CREATE, params, configJson) }
async function tc_list_sub_processors() { return TrustCenterApi.get(api.TC_SUB_PROCESSORS, configJson) }
async function tc_create_sub_processor(params) { return TrustCenterApi.post(api.TC_SUB_PROCESSOR_CREATE, params, configJson) }
async function tc_init_practices() { return TrustCenterApi.post(api.TC_INIT_PRACTICES, {}, configJson) }
async function tc_list_access_requests() { return TrustCenterApi.get(api.TC_ACCESS_REQUESTS, configJson) }
async function tc_approve_request(id) { return TrustCenterApi.post(api.TC_APPROVE_REQUEST(id), {}, configJson) }
async function tc_reject_request(id) { return TrustCenterApi.post(api.TC_REJECT_REQUEST(id), {}, configJson) }
async function tc_analytics() { return TrustCenterApi.get(api.TC_ANALYTICS, configJson) }
async function tc_notif_config() { return TrustCenterApi.get(api.TC_NOTIF_CONFIG, configJson) }
async function tc_notif_update(params) { return TrustCenterApi.post(api.TC_NOTIF_UPDATE, params, configJson) }
async function tc_notif_test() { return TrustCenterApi.post(api.TC_NOTIF_TEST, {}, configJson) }

// ================================================
// Module-specific API clients
// All modules now share the unified REACT_APP_API_URL.
// SbomApiIntercepter handles dual-header auth (Basic + Token: Bearer)
// and auto-refresh; falls back to plain ApiIntercepter if env not set.
// ================================================
const SbomApi = process.env.REACT_APP_API_URL ? SbomApiIntercepter : ApiIntercepter;
const AIGApi = process.env.REACT_APP_API_URL ? SbomApiIntercepter : ApiIntercepter;
const TrustCenterApi = process.env.REACT_APP_API_URL ? SbomApiIntercepter : SbomApi;

async function sbom_dashboard() {
    return SbomApi.get(api.SBOM_DASHBOARD, configJson)
}
async function sbom_list_reports(params) {
    return SbomApi.get(api.SBOM_REPORTS, params, configJson)
}
async function sbom_report_detail(reportId) {
    return SbomApi.get(api.SBOM_REPORT_DETAIL(reportId), configJson)
}
async function sbom_generate(params) {
    return SbomApi.post(api.SBOM_GENERATE, params, configJson)
}
async function sbom_upload(formData) {
    return SbomApi.post(api.SBOM_UPLOAD, formData, configFormData)
}
async function sbom_list_components(params) {
    return SbomApi.get(api.SBOM_COMPONENTS(params), configJson)
}
async function sbom_component_detail(componentId) {
    return SbomApi.get(api.SBOM_COMPONENT_DETAIL(componentId), configJson)
}
async function sbom_component_tree(componentId) {
    return SbomApi.get(api.SBOM_COMPONENT_TREE(componentId), configJson)
}
async function sbom_impact_search(params) {
    return SbomApi.get(api.SBOM_IMPACT_SEARCH(params), configJson)
}
async function sbom_scan_ssh(params) {
    return SbomApi.post(api.SBOM_SCAN_SSH, params, configJson)
}
async function sbom_scan_cloud(params) {
    return SbomApi.post(api.SBOM_SCAN_CLOUD, params, configJson)
}
// VEX
async function sbom_vex_create(params) { return SbomApi.post(api.SBOM_VEX_CREATE, params, configJson) }
async function sbom_vex_list(reportId) { return SbomApi.get(api.SBOM_VEX_LIST(reportId), configJson) }
async function sbom_vex_export(reportId, format) { return SbomApi.get(api.SBOM_VEX_EXPORT(reportId, format), configJson) }
// Policies
async function sbom_policies() { return SbomApi.get(api.SBOM_POLICIES, configJson) }
async function sbom_policy_create(params) { return SbomApi.post(api.SBOM_POLICY_CREATE, params, configJson) }
async function sbom_policy_toggle(policyId) { return SbomApi.post(api.SBOM_POLICY_TOGGLE(policyId), {}, configJson) }
async function sbom_policy_delete(policyId) { return SbomApi.delete(api.SBOM_POLICY_DELETE(policyId), configJson) }
async function sbom_policy_init_defaults() { return SbomApi.post(api.SBOM_POLICY_INIT_DEFAULTS, {}, configJson) }
async function sbom_policy_evaluate(reportId) { return SbomApi.post(api.SBOM_POLICY_EVALUATE, { report_id: reportId }, configJson) }
async function sbom_violations(params) { return SbomApi.get(api.SBOM_VIOLATIONS, params, configJson) }
// PDF/HTML — use raw fetch to get proper blob responses
async function sbom_export_pdf(reportId) {
    const url = api.SBOM_EXPORT_PDF(reportId);
    return _sbom_blob_fetch(url);
}
async function sbom_export_html(reportId) {
    const url = api.SBOM_EXPORT_HTML(reportId);
    return _sbom_blob_fetch(url);
}
// sbom_vex_export_blob removed — VEX export uses sbom_vex_export() with JSON response

async function _sbom_blob_fetch(url) {
    const token = sessionStorage.getItem('access_token');
    const res = await fetch(url, {
        headers: { 'Authorization': 'Basic YmFzZWFkbWluOmRlZmF1bHRANDU2', 'token': `Bearer ${token}` }
    });
    return res.blob();
}

async function sbom_risk_trend(days) { return SbomApi.get(api.SBOM_RISK_TREND(days), configJson) }
async function sbom_risk_snapshot() { return SbomApi.post(api.SBOM_RISK_SNAPSHOT, {}, configJson) }
async function sbom_dashboard_enhanced() { return SbomApi.get(api.SBOM_DASHBOARD_ENHANCED, configJson) }
async function sbom_compliance_evaluate() { return SbomApi.post(api.SBOM_COMPLIANCE_EVALUATE, {}, configJson) }
async function sbom_compliance_scores() { return SbomApi.get(api.SBOM_COMPLIANCE_SCORES, configJson) }
async function sbom_schedules() { return SbomApi.get(api.SBOM_SCHEDULES, configJson) }
async function sbom_schedule_create(params) { return SbomApi.post(api.SBOM_SCHEDULE_CREATE, params, configJson) }
async function sbom_schedule_toggle(id) { return SbomApi.post(api.SBOM_SCHEDULE_TOGGLE(id), {}, configJson) }
async function sbom_schedule_delete(id) { return SbomApi.delete(api.SBOM_SCHEDULE_DELETE(id), configJson) }
async function sbom_audit_log(params) { return SbomApi.get(api.SBOM_AUDIT_LOG, { ...configJson, params }) }
async function sbom_diff(reportA, reportB) {
    return SbomApi.get(api.SBOM_DIFF(reportA, reportB), configJson)
}
async function sbom_versions(agentName) {
    return SbomApi.get(api.SBOM_VERSIONS(agentName), configJson)
}
async function sbom_enrich_report(reportId) {
    return SbomApi.post(api.SBOM_ENRICH(reportId), {}, configJson)
}
async function sbom_enrich_licenses(reportId) {
    return SbomApi.post(api.SBOM_ENRICH_LICENSES(reportId), {}, configJson)
}
async function sbom_enrich_licenses_all() {
    return SbomApi.post(api.SBOM_ENRICH_LICENSES_ALL, {}, configJson)
}
async function sbom_ingest_agent(params) {
    return SbomApi.post(api.SBOM_INGEST_AGENT, params, configJson)
}
async function sbom_ci_cd_webhook(params) {
    return SbomApi.post(api.SBOM_CI_CD_WEBHOOK, params, configJson)
}
async function sbom_setup_snippets() {
    return SbomApi.get(api.SBOM_SETUP_SNIPPETS, configJson)
}
async function sbom_agents() {
    return SbomApi.get(api.SBOM_AGENTS, configJson)
}
async function sbom_license_summary() {
    return SbomApi.get(api.SBOM_LICENSE_SUMMARY, configJson)
}
async function sbom_drift_logs(params) {
    return SbomApi.get(api.SBOM_DRIFT(params), configJson)
}
async function sbom_export_report(reportId) {
    return SbomApi.get(api.SBOM_REPORT_EXPORT(reportId), configJson)
}

// Complaince Ready

async function assign_organization_compliance_form(params) {
    return ApiIntercepter.post(api.ASSIGN_ORGANIZATION_COMPLIANCE_FORM, params, configJson)
}
async function domain_selection_list(params) {
    return ApiIntercepter.get(api.DOMAIN_SELECTION_LIST(params), configJson)
}

async function check_compliance_available_for_framework(params) {
    return ApiIntercepter.get(api.CHECK_COMPLIANCE_ORGANIZATION_FRAMEWORK(params), configJson)
}
async function assign_organization_domain_owner(params) {
    return ApiIntercepter.post(api.ASSIGN_ORGANIZATION_DOMAIN_OWNER, params, configJson)
}
async function user_assign_domains_question_list(query) {
    return ApiIntercepter.get(api.USER_ASSIGN_DOMAINS_QUESTIONS_LIST + query, configJson)
}

async function check_with_nova(params) {
    return ApiIntercepter.post(api.CHECK_WITH_NOVA, params, configJson)
}

async function upload_document_to_check_with_nova(params) {
    return ApiIntercepter.post(api.UPLOAD_DOUCMENT_TO_CHECK_WITH_NOVA, params, configFormData)
}

async function submit_framework_question_answer(params) {
    return ApiIntercepter.post(api.SUBMIT_FRAMEWORK_QUESTION_ANSWER, params, configJson)
}

async function donainComplianceReportService(query) {
    return ApiIntercepter.get(api.DOMAIN_COMPLIANCE_REPORT + query, configJson)
}

async function domainControlsService(params) {
    const url = api.DOMAIN_CONTROLS(params);
    return ApiIntercepter.get(url, configJson);
}

async function domainControlsQuestionsService(params) {
    const url = api.DOMAIN_CONTROLS_QUESTIONS(params);
    return ApiIntercepter.get(url, configJson);
}

async function overallComplianceReportService(query) {
    return ApiIntercepter.get(api.OVERALL_COMPLIANCE_REPORT + query, configJson)
}

async function complianceFrameworksService() {
    return ApiIntercepter.get(api.COMPLIANCE_FRAMEWORKS, configJson)
}

async function ownerBaseComplianceReportService(query) {
    return ApiIntercepter.get(api.OWNER_BASE_COMPLIANCE_REPORT + query, configJson)
}

async function sharingQuetionService(params) {
    return ApiIntercepter.post(api.SHARING_QUESTION, params, configJson)
}

async function deleteQuestionSharingService(query) {
    return ApiIntercepter.delete(api.DELETE_QUESTION_SHARING + query, configJson)
}

async function getOrganizationComplianceSubmissionService(params) {
    return ApiIntercepter.get(api.ASSIGN_ORGANIZATION_COMPLIANCE_FORM + params, configJson)
}

async function organizationComplianceSubmissionService(params) {
    return ApiIntercepter.post(api.ASSIGN_ORGANIZATION_COMPLIANCE_FORM + params, {}, configJson)
}

async function setDraftStatusService(id) {
    return ApiIntercepter.post(api.SET_DRAFT_STATUS(id), {}, configJson)
}



async function organizationComplianceReportService(query) {
    return ApiIntercepter.get(api.ORG_COMPLIANT_REPORT + query, configJson)
}

async function frameworkComplianceMappingService(query) {
    return ApiIntercepter.get(api.FRAMEWORK_COMPLIANCE_MAPPING + query, configJson)
}

async function frameworkComplianceService(query) {
    return ApiIntercepter.get(api.FRAMEWORK_COMPLIANCE, configJson)
}

async function compliance_domains(framework_id) {
    return ApiIntercepter.get(`${api.COMPLIANCE_DOMAINS}?framework_id=${framework_id}`, configJson)
}

async function website_whats_new() {
    return ApiIntercepter.get(api.WEBSITE_WHATS_NEW, configJson)
}

async function scanner_notifications() {
    return ApiIntercepter.get(api.SCANNER_NOTIFICATIONS, configJson)
}

async function thirdpartyExternalExposureQuestionsService(query) {
    return ApiIntercepter.get(api.THIRDPARTY_EXTERNAL_EXPOSURE_QUESTIONS + query, configJson)
}


async function createThirdpartyQuestionsService(params) {
    return ApiIntercepter.post(api.THIRDPARTY_EXTERNAL_EXPOSURE_QUESTIONS, params, configJson)
}

async function editThirdpartyQuestionsService(query, params) {
    return ApiIntercepter.patch(api.THIRDPARTY_EXTERNAL_EXPOSURE_QUESTIONS + query, params, configJson)
}


async function deleteThirdpartyQuestionsService(query) {
    return ApiIntercepter.delete(api.THIRDPARTY_EXTERNAL_EXPOSURE_QUESTIONS + query, configJson)
}

async function getThirdpartyQuestionsTemplateService() {
    const config = { ...configJson, responseType: 'blob' };
    return ApiIntercepter.get(api.THIRDPARTY_QUESTIONS_TEMPLATE, config);
}

async function bulkUploadThirdpartyQuestionsService(file, questionnaireName) {
    const formData = new FormData();
    formData.append('file', file);
    if (questionnaireName) {
        formData.append('questionnaire_name', questionnaireName);
    }
    return ApiIntercepter.post(api.THIRDPARTY_QUESTIONS_BULK_UPLOAD, formData, configFormData);
}

async function getTprmAssessmentsService(query) {
    const url = api.TPRM_ASSESSMENTS + query;
    return ApiIntercepter.get(url);
}

async function createTprmAssessmentService(params) {
    return ApiIntercepter.post(api.CREATE_TPRM_ASSESSMENT, params, configJson);
}

async function getTprmAssessmentCategoriesService() {
    return ApiIntercepter.get(api.TPRM_ASSESSMENT_CATEGORIES, configJson);
}

async function getVendorAssessmentService(access_token) {
    const url = api.VENDOR_ASSESSMENT_VIEW(access_token);
    return ApiIntercepter.get(url);
}

async function submitVendorAssessmentService(access_token, params) {
    const url = api.VENDOR_ASSESSMENT_SUBMIT(access_token);
    return ApiIntercepter.post(url, params, configJson);
}

async function getAssessmentResponsesService(assessment_id, is_reviewed) {
    const url = api.ASSESSMENT_RESPONSES(assessment_id, is_reviewed);
    return ApiIntercepter.get(url);
}

async function getAssessmentDetailsService(assessment_id) {
    const url = api.ASSESSMENT_DETAILS(assessment_id);
    return ApiIntercepter.get(url);
}

async function reviewResponseService(response_id, params) {
    const url = api.REVIEW_RESPONSE(response_id);
    return ApiIntercepter.put(url, params, configJson);
}

async function getAssessmentResponseDocumentService(assessment_id, response_id, document_id, download = false) {
    const url = api.ASSESSMENT_RESPONSE_DOCUMENT(assessment_id, response_id, document_id, download);
    return ApiIntercepter.get(url, { ...configJson, responseType: 'blob' });
}

async function updateAssessmentReviewStatusService(assessment_id, params) {
    const url = api.UPDATE_ASSESSMENT_REVIEW_STATUS(assessment_id);
    return ApiIntercepter.patch(url, params, configJson);
}

async function uploadVendorDocumentsService(access_token, files) {
    const formData = new FormData();

    files.forEach((file, index) => {
        formData.append(`document_${index + 1}`, file);
    });

    const url = api.VENDOR_DOCUMENT_UPLOAD(access_token);
    return ApiIntercepter.post(url, formData, configFormData);
}

async function uploadVendorResponseDocumentsService(access_token, response_id, files) {
    const formData = new FormData();
    files.forEach((file) => {
        formData.append('files', file);
    });
    const url = api.VENDOR_RESPONSE_DOCUMENT_UPLOAD(access_token, response_id);
    return ApiIntercepter.post(url, formData, configFormData);
}

async function deleteVendorResponseDocumentsService(access_token, response_id, document_ids) {
    const url = api.VENDOR_RESPONSE_DOCUMENT_DELETE(access_token, response_id);
    return ApiIntercepter.delete(url, { data: { document_ids } });
}

async function getVendorResponseDocumentService(access_token, response_id, document_id, download = false) {
    const url = api.VENDOR_RESPONSE_DOCUMENT_VIEW(access_token, response_id, document_id, download);
    return ApiIntercepter.get(url, { ...configJson, responseType: 'blob' });
}

async function getVendorQuestionSuggestionsService(access_token) {
    const url = api.VENDOR_QUESTION_SUGGESTIONS(access_token);
    return ApiIntercepter.get(url);
}

// Assessment Settings Services (same endpoint for GET and PATCH)
async function getOrganizationAssessmentSettingsService() {
    return ApiIntercepter.get(api.ORGANIZATION_ASSESSMENT_SETTINGS, configJson);
}

async function updateOrganizationAssessmentSettingsService(params) {
    return ApiIntercepter.patch(api.ORGANIZATION_ASSESSMENT_SETTINGS, params, configJson);
}


async function downloadScannerReportService(query, config = null) {
    const requestConfig = config ? { ...configJson, ...config } : configJson;
    return ApiIntercepter.get(api.DOWNLOAD_SCANNER_REPORT + query, requestConfig)
}

async function generate_executive_pdf(id, config = null) {
    const requestConfig = config ? { ...configJson, ...config } : configJson;
    return ApiIntercepter.post(api.GENERATE_EXECUTIVE_PDF(id), {}, requestConfig);
}

async function scan_alert_risk_data(params = {}) {
    const { organization_id } = params;
    const url = api.SCAN_ALERT_RISK_DATA({ organization_id });
    return ApiIntercepter.get(url);
}

async function alert_chat(params) {
    return ApiIntercepter.post(api.ALERT_CHAT, params, configJson);
}

async function alert_chat_initialize(params = {}) {
    const { organization_id } = params;
    const url = api.ALERT_CHAT_INITIALIZE({ organization_id });
    return ApiIntercepter.post(url, {}, configJson);
}

async function get_questionnaires() {
    return ApiIntercepter.get(api.GET_QUESTIONNAIRES, configJson);
}

async function get_fields_measures_metadata() {
    return ApiIntercepter.get(api.FIELDS_MEASURES_METADATA, configJson);
}

async function upsert_fields_measures_metadata(params) {
    return ApiIntercepter.put(api.FIELDS_MEASURES_METADATA_UPSERT, params, configJson);
}

async function delete_fields_measures_metadata(metadata_id) {
    const url = api.FIELDS_MEASURES_METADATA_DELETE(metadata_id);
    return ApiIntercepter.delete(url, configJson);
}

// Cloud Data Population
async function populateAwsDataService(params) {
    return ApiIntercepter.post(api.POPULATE_AWS_DATA, params, configJson)
}

async function populateAzureDataService(params) {
    return ApiIntercepter.post(api.POPULATE_AZURE_DATA, params, configJson)
}

async function populateGcpDataService(params) {
    return ApiIntercepter.post(api.POPULATE_GCP_DATA, params, configJson)
}

async function populateOnpremDataService(formData) {
    return ApiIntercepter.post(api.POPULATE_ONPREM_DATA, formData, configFormData)
}

async function addCloudAccountService(params) {
    // We add custom headers here if needed, but configJson should have the standard authorization
    return ApiIntercepter.post(api.CLOUD_ACCOUNTS, params, configJson)
}

async function getCloudOrgScoreService(query = '') {
    return ApiIntercepter.get(api.CLOUD_ORG_SCORE + query, configJson)
}

async function getCloudAccountsOverviewService() {
    return ApiIntercepter.get(api.CLOUD_ACCOUNTS_OVERVIEW, configJson)
}

async function editCloudAccountService(accountId, body) {
    return ApiIntercepter.patch(api.EDIT_CLOUD_ACCOUNT(accountId), body, configJson)
}

async function rescanCloudAccountService(accountId) {
    return ApiIntercepter.post(api.RESCAN_CLOUD_ACCOUNT(accountId), {}, configJson)
}

async function getCloudServiceDetailsService(controlId) {
    return ApiIntercepter.get(api.CLOUD_SERVICE_DETAILS(controlId), configJson)
}

async function load_correlated_signals(params = {}) {
    return ApiIntercepter.get(api.CORRELATED_SIGNALS(params), configJson);
}

// easm api 

async function create_takedown_request_from_finding(findingId, body = {}) {
    return ApiIntercepter.post(api.CREATE_TAKEDOWN_FROM_FINDING(findingId), body, configJson);
}

async function bp_ai_review_posts(params) { return ApiIntercepter.get(api.BRAND_PROTECTION_AI_REVIEW, { ...configJson, params }) }

async function load_takedowns_list(params = {}) {
    return ApiIntercepter.get(api.TAKEDOWNS_LIST(params), configJson);
}

async function load_takedown_sla_metrics(params = {}) {
    return ApiIntercepter.get(api.TAKEDOWN_SLA_METRICS(params), configJson);
}

async function load_brand_watchlist(params = {}) {
    return ApiIntercepter.get(api.BRAND_WATCHLIST(params), configJson);
}

async function ai_generate_brand_watchlist_defaults(body = {}) {
    return ApiIntercepter.post(api.AI_GENERATE_BRAND_WATCHLIST_DEFAULTS, body, configJson);
}

async function create_brand_watchlist_entry(body, idempotencyKey) {
    const config = idempotencyKey
        ? { headers: { ...(configJson.headers || {}), 'Idempotency-Key': idempotencyKey } }
        : configJson;
    return ApiIntercepter.post(api.BRAND_WATCHLIST_CREATE, body, config);
}
async function delete_brand_watchlist_entry(id) {
    return ApiIntercepter.delete(api.BRAND_WATCHLIST_DELETE(id), configJson);
}

async function bulk_upsert_brand_watchlist(file, idempotencyKey) {
    const formData = new FormData();
    formData.append('file', file);
    const headers = {
        ...(configFormData.headers || {}),
        ...(idempotencyKey ? { 'Idempotency-Key': idempotencyKey } : {}),
    };
    return ApiIntercepter.post(api.BRAND_WATCHLIST_BULK, formData, { ...configFormData, headers });
}


// translation to english
async function bp_translate_mention(id, opts = {}) {
    const url = opts.force ? `${api.BRAND_PROTECTION_MENTION_TRANSLATE(id)}?force=1`
        : api.BRAND_PROTECTION_MENTION_TRANSLATE(id)
    return ApiIntercepter.post(url, {}, configJson)
}

async function bp_mention_comments(id, params = {}) {
    return ApiIntercepter.get(api.BRAND_PROTECTION_MENTION_COMMENTS(id), { ...configJson, params })
}

// ================================================
// RISK REGISTRY PORTAL
// ================================================
async function risk_portal_dashboard(params) { return AIGApi.get(api.RISK_PORTAL_DASHBOARD, { ...configJson, params }) }
async function risk_portal_heatmap(params) { return AIGApi.get(api.RISK_PORTAL_HEATMAP, { ...configJson, params }) }
async function risk_portal_risks(params) { return AIGApi.get(api.RISK_PORTAL_RISKS, { ...configJson, params }) }
async function risk_portal_risk_detail(id) { return AIGApi.get(api.RISK_PORTAL_RISK_DETAIL(id), configJson) }
async function risk_portal_assess(id, params) { return AIGApi.post(api.RISK_PORTAL_ASSESS(id), params, configJson) }
async function risk_portal_create_treatment(id, params) { return AIGApi.post(api.RISK_PORTAL_TREATMENT(id), params, configJson) }
async function risk_portal_update_treatment(id, params) { return AIGApi.put(api.RISK_PORTAL_TREATMENT_UPDATE(id), params, configJson) }
async function risk_portal_kri_list() { return AIGApi.get(api.RISK_PORTAL_KRI_LIST, configJson) }
async function risk_portal_create_kri(id, params) { return AIGApi.post(api.RISK_PORTAL_KRI_CREATE(id), params, configJson) }
async function risk_portal_add_control(id, params) { return AIGApi.post(api.RISK_PORTAL_CONTROL_ADD(id), params, configJson) }
async function risk_portal_categories() { return AIGApi.get(api.RISK_PORTAL_CATEGORIES, configJson) }
async function risk_portal_create_category(params) { return AIGApi.post(api.RISK_PORTAL_CATEGORY_CREATE, params, configJson) }
async function risk_portal_appetite() { return AIGApi.get(api.RISK_PORTAL_APPETITE, configJson) }
async function risk_portal_save_appetite(params) { return AIGApi.post(api.RISK_PORTAL_APPETITE_SAVE, params, configJson) }
async function risk_portal_workflow_config() { return AIGApi.get(api.RISK_PORTAL_WORKFLOW_CONFIG, configJson) }
async function risk_portal_update_workflow(params, force) {
    // `force` re-submits past the backend's non-blocking soft-validation
    // warnings. Sent as BOTH a query param and a body field so it works
    // regardless of which the backend reads.
    const url = force ? `${api.RISK_PORTAL_WORKFLOW_UPDATE}?force=true` : api.RISK_PORTAL_WORKFLOW_UPDATE;
    const body = force ? { ...params, force: true } : params;
    return AIGApi.post(url, body, configJson);
}
async function risk_portal_users() { return AIGApi.get(api.RISK_PORTAL_USERS, configJson) }
async function risk_portal_invite(params) { return AIGApi.post(api.RISK_PORTAL_INVITE, params, configJson) }
async function risk_portal_login() { return AIGApi.post(api.RISK_PORTAL_LOGIN, {}, configJson) }
async function risk_portal_register(params) {
    const axios = (await import('axios')).default;
    const res = await axios.post(api.RISK_PORTAL_REGISTER, params, { headers: { 'Content-Type': 'application/json' } });
    return res?.data;
}
async function risk_portal_add_comment(id, params) { return AIGApi.post(api.RISK_PORTAL_COMMENT(id), params, configJson) }
async function risk_portal_upload_evidence(params) { return AIGApi.post(api.RISK_PORTAL_EVIDENCE, params, { ...configJson, headers: { ...configJson.headers, 'Content-Type': 'multipart/form-data' } }) }
async function risk_portal_activity(id) { return AIGApi.get(api.RISK_PORTAL_ACTIVITY(id), configJson) }
// Phase 2
async function risk_portal_approve_treatment(id) { return AIGApi.post(api.RISK_PORTAL_TREATMENT_APPROVE(id), {}, configJson) }
async function risk_portal_reject_treatment(id, params) { return AIGApi.post(api.RISK_PORTAL_TREATMENT_REJECT(id), params, configJson) }
async function risk_portal_overdue_treatments() { return AIGApi.get(api.RISK_PORTAL_OVERDUE_TREATMENTS, configJson) }
async function risk_portal_update_kri(id, params) { return AIGApi.put(api.RISK_PORTAL_KRI_UPDATE(id), params, configJson) }
async function risk_portal_delete_kri(id) { return AIGApi.delete(api.RISK_PORTAL_KRI_DELETE(id), configJson) }
async function risk_portal_framework_controls(params) { return AIGApi.get(api.RISK_PORTAL_FRAMEWORK_CONTROLS, { ...configJson, params }) }
async function risk_portal_framework_list() { return AIGApi.get(api.RISK_PORTAL_FRAMEWORK_LIST, configJson) }
async function risk_portal_update_control(id, params) { return AIGApi.put(api.RISK_PORTAL_CONTROL_UPDATE(id), params, configJson) }
async function risk_portal_delete_control(id) { return AIGApi.delete(api.RISK_PORTAL_CONTROL_DELETE(id), configJson) }
async function risk_portal_appetite_breaches() { return AIGApi.get(api.RISK_PORTAL_APPETITE_BREACHES, configJson) }
async function risk_portal_velocity_summary() { return AIGApi.get(api.RISK_PORTAL_VELOCITY_SUMMARY, configJson) }
async function risk_portal_delete_treatment(id) { return AIGApi.delete(api.RISK_PORTAL_TREATMENT_DELETE(id), configJson) }
async function risk_portal_delete_category(id) { return AIGApi.delete(api.RISK_PORTAL_CATEGORY_DELETE(id), configJson) }
async function risk_portal_delete_appetite(id) { return AIGApi.delete(api.RISK_PORTAL_APPETITE_DELETE(id), configJson) }
async function risk_portal_delete_evidence(id) { return AIGApi.delete(api.RISK_PORTAL_EVIDENCE_DELETE(id), configJson) }
async function risk_portal_download_evidence(id) { return AIGApi.get(api.RISK_PORTAL_EVIDENCE_DOWNLOAD(id), { responseType: 'blob' }) }
async function risk_portal_delete_comment(id) { return AIGApi.delete(api.RISK_PORTAL_COMMENT_DELETE(id), configJson) }
async function risk_portal_pending_treatments() { return AIGApi.get(api.RISK_PORTAL_PENDING_TREATMENTS, configJson) }
async function risk_portal_workflow_state(id) { return AIGApi.get(api.RISK_PORTAL_WORKFLOW_STATE(id), configJson) }
async function risk_portal_advance_stage(id, params) { return AIGApi.post(api.RISK_PORTAL_ADVANCE_STAGE(id), params, configJson) }
async function risk_portal_accept_risk(id, params) { return AIGApi.post(api.RISK_PORTAL_ACCEPT_RISK(id), params || {}, configJson) }
async function risk_portal_close_risk(id, params) { return AIGApi.post(api.RISK_PORTAL_CLOSE_RISK(id), params || {}, configJson) }
async function risk_portal_seed_defaults() { return AIGApi.post(api.RISK_PORTAL_SEED_DEFAULTS, {}, configJson) }
async function risk_portal_bulk_import(formData) { return AIGApi.post(api.RISK_PORTAL_BULK_IMPORT, formData, { ...configJson, headers: { ...configJson.headers, 'Content-Type': 'multipart/form-data' } }) }
// Phase 3
async function risk_portal_get_quantification(id) { return AIGApi.get(api.RISK_PORTAL_QUANTIFICATION(id), configJson) }
async function risk_portal_save_quantification(id, params) { return AIGApi.post(api.RISK_PORTAL_QUANTIFICATION_SAVE(id), params, configJson) }
async function risk_portal_monte_carlo(id, params) { return AIGApi.post(api.RISK_PORTAL_MONTE_CARLO(id), params || {}, configJson) }
async function risk_portal_get_bowtie(id) { return AIGApi.get(api.RISK_PORTAL_BOWTIE(id), configJson) }
async function risk_portal_save_bowtie(id, params) { return AIGApi.post(api.RISK_PORTAL_BOWTIE_SAVE(id), params, configJson) }
async function risk_portal_list_scenarios() { return AIGApi.get(api.RISK_PORTAL_SCENARIOS, configJson) }
async function risk_portal_create_scenario(params) { return AIGApi.post(api.RISK_PORTAL_SCENARIO_CREATE, params, configJson) }
async function risk_portal_get_scenario(id) { return AIGApi.get(api.RISK_PORTAL_SCENARIO_DETAIL(id), configJson) }
async function risk_portal_delete_scenario(id) { return AIGApi.delete(api.RISK_PORTAL_SCENARIO_DELETE(id), configJson) }
// Phase 4
async function risk_portal_list_review_schedules() { return AIGApi.get(api.RISK_PORTAL_REVIEW_SCHEDULES, configJson) }
async function risk_portal_create_review_schedule(params) { return AIGApi.post(api.RISK_PORTAL_REVIEW_SCHEDULE_CREATE, params, configJson) }
async function risk_portal_delete_review_schedule(id) { return AIGApi.delete(api.RISK_PORTAL_REVIEW_SCHEDULE_DELETE(id), configJson) }
async function risk_portal_ai_categorize(params) { return AIGApi.post(api.RISK_PORTAL_AI_CATEGORIZE, params, configJson) }
async function risk_portal_ai_duplicates(params) { return AIGApi.post(api.RISK_PORTAL_AI_DUPLICATES, params, configJson) }
async function risk_portal_ai_risk_statement(params) { return AIGApi.post(api.RISK_PORTAL_AI_RISK_STATEMENT, params, configJson) }
async function risk_portal_ai_suggest_treatment(params) { return AIGApi.post(api.RISK_PORTAL_AI_SUGGEST_TREATMENT, params, configJson) }
async function risk_portal_board_report() { return AIGApi.get(api.RISK_PORTAL_BOARD_REPORT, configJson) }
async function risk_portal_ensure_admin() { return AIGApi.post(api.RISK_PORTAL_ENSURE_ADMIN, {}, configJson) }
async function risk_portal_share_risk(id, params) { return AIGApi.post(api.RISK_PORTAL_SHARE(id), params, configJson) }
async function risk_portal_list_shares(id) { return AIGApi.get(api.RISK_PORTAL_LIST_SHARES(id), configJson) }
async function risk_portal_revoke_share(id) { return AIGApi.post(api.RISK_PORTAL_REVOKE_SHARE(id), {}, configJson) }
async function risk_portal_public_view(token) { return ApiIntercepter.get(api.RISK_PORTAL_PUBLIC_VIEW(token)) }
async function risk_portal_public_update(token, params) { return ApiIntercepter.post(api.RISK_PORTAL_PUBLIC_UPDATE(token), params) }
async function risk_portal_public_acknowledge(token, params) { return ApiIntercepter.post(api.RISK_PORTAL_PUBLIC_ACKNOWLEDGE(token), params) }
async function risk_portal_request_ack(id, params) { return AIGApi.post(api.RISK_PORTAL_REQUEST_ACK(id), params || {}, configJson) }
async function risk_portal_get_ack(id) { return AIGApi.get(api.RISK_PORTAL_GET_ACK(id), configJson) }

// Risk Portal — Roles / RBAC
async function risk_portal_update_user_role(id, params) { return AIGApi.put(api.RISK_PORTAL_UPDATE_USER_ROLE(id), params, configJson) }
async function risk_portal_roles_list() { return AIGApi.get(api.RISK_PORTAL_ROLES, configJson) }
async function risk_portal_role_create(params) { return AIGApi.post(api.RISK_PORTAL_ROLES, params, configJson) }
async function risk_portal_role_update(id, params) { return AIGApi.patch(api.RISK_PORTAL_ROLE_DETAIL(id), params, configJson) }
async function risk_portal_role_delete(id) { return AIGApi.delete(api.RISK_PORTAL_ROLE_DETAIL(id), configJson) }
async function risk_portal_role_resend_invite(id) { return AIGApi.post(api.RISK_PORTAL_ROLE_RESEND_INVITE(id), {}, configJson) }
async function risk_portal_roles_audit_log() { return AIGApi.get(api.RISK_PORTAL_ROLES_AUDIT, configJson) }

// Risk Portal — Business Units
async function risk_portal_bus_list(params) { return AIGApi.get(api.RISK_PORTAL_BUS, { ...configJson, params }) }
async function risk_portal_bu_tree() { return AIGApi.get(api.RISK_PORTAL_BU_TREE, configJson) }
async function risk_portal_bu_create(params) { return AIGApi.post(api.RISK_PORTAL_BUS, params, configJson) }
async function risk_portal_bu_update(id, params) { return AIGApi.patch(api.RISK_PORTAL_BU_DETAIL(id), params, configJson) }
async function risk_portal_bu_delete(id) { return AIGApi.delete(api.RISK_PORTAL_BU_DETAIL(id), configJson) }
async function risk_portal_bu_breakdown(params) { return AIGApi.get(api.RISK_PORTAL_BU_BREAKDOWN, { ...configJson, params }) }

// Risk Portal — Org Settings / Customisation
async function risk_portal_get_settings() { return AIGApi.get(api.RISK_PORTAL_SETTINGS, configJson) }
async function risk_portal_update_settings(params) { return AIGApi.post(api.RISK_PORTAL_SETTINGS_UPDATE, params, configJson) }
async function aig_audit_capa_assignable_users() { return AIGApi.get(api.AUDIT_CAPA_ASSIGNABLE_USERS, configJson) }
async function aig_audit_capa_findings(params) { return AIGApi.get(api.AUDIT_CAPA_FINDINGS + (params ? '?' + new URLSearchParams(params).toString() : ''), configJson) }


// Risk Portal — Projects
async function risk_portal_projects_list() { return AIGApi.get(api.RISK_PORTAL_PROJECTS, configJson) }
async function risk_portal_project_create(params) { return AIGApi.post(api.RISK_PORTAL_PROJECTS, params, configJson) }
async function risk_portal_project_update(id, params) { return AIGApi.patch(api.RISK_PORTAL_PROJECT_DETAIL(id), params, configJson) }
async function risk_portal_project_delete(id) { return AIGApi.delete(api.RISK_PORTAL_PROJECT_DETAIL(id), configJson) }
async function risk_portal_project_breakdown() { return AIGApi.get(api.RISK_PORTAL_PROJECT_BREAKDOWN, configJson) }
async function risk_portal_portfolio_trend(params) { return AIGApi.get(api.RISK_PORTAL_PORTFOLIO_TREND, { ...configJson, params }) }

// Risk Portal — Audit / SLA
async function risk_portal_field_changes(id) { return AIGApi.get(api.RISK_PORTAL_FIELD_CHANGES(id), configJson) }
async function risk_portal_sla_escalations() { return AIGApi.get(api.RISK_PORTAL_SLA_ESCALATIONS, configJson) }
async function risk_portal_dispatch_escalations() { return AIGApi.post(api.RISK_PORTAL_SLA_ESCALATIONS, {}, configJson) }

// Risk Portal — Bulk template
async function risk_portal_bulk_template() { return AIGApi.get(api.RISK_PORTAL_BULK_TEMPLATE, { ...configJson, responseType: 'blob' }) }

// brabd protection
async function risk_portal_compliance_mappings(id) { return AIGApi.get(api.RISK_PORTAL_COMPLIANCE(id), configJson) }
async function risk_portal_map_compliance(id, params) { return AIGApi.post(api.RISK_PORTAL_COMPLIANCE_MAP(id), params, configJson) }
async function risk_portal_delete_compliance_mapping(riskId, mapId) { return AIGApi.delete(api.RISK_PORTAL_COMPLIANCE_DELETE(riskId, mapId), configJson) }
async function risk_portal_compliance_coverage() { return AIGApi.get(api.RISK_PORTAL_COMPLIANCE_COVERAGE, configJson) }
async function bp_mentions(params) { return ApiIntercepter.get(api.BRAND_PROTECTION_MENTIONS, { ...configJson, params }) }

async function bp_mentions_dropped(params) { return ApiIntercepter.get(api.BRAND_PROTECTION_MENTIONS_DROPPED, { ...configJson, params }) }

async function bp_mention_mark_relevant(id) { return ApiIntercepter.post(api.BRAND_PROTECTION_MENTION_MARK_RELEVANT, { id }, configJson) }
async function bp_topics(params) { return ApiIntercepter.get(api.BRAND_PROTECTION_TOPICS, { ...configJson, params }) }
async function bp_chart(params) { return ApiIntercepter.get(api.BRAND_PROTECTION_CHART, { ...configJson, params }) }
async function bp_sentiment(params) { return ApiIntercepter.get(api.BRAND_PROTECTION_SENTIMENT, { ...configJson, params }) }
async function bp_influencers(params) { return ApiIntercepter.get(api.BRAND_PROTECTION_INFLUENCERS, { ...configJson, params }) }
async function bp_sources(params) { return ApiIntercepter.get(api.BRAND_PROTECTION_SOURCES, { ...configJson, params }) }
async function bp_filters() { return ApiIntercepter.get(api.BRAND_PROTECTION_FILTERS, configJson) }
async function bp_undiscovered_sources() { return ApiIntercepter.get(api.BRAND_PROTECTION_UNDISCOVERED, configJson) }
async function bp_assistant_ask(body) { return ApiIntercepter.post(api.BRAND_PROTECTION_ASSISTANT_ASK, body, configJson) }
async function bp_resolve_avatar(params) { return ApiIntercepter.get(api.BRAND_PROTECTION_AVATAR, { ...configJson, params }) }
async function bp_demographics(params) { return ApiIntercepter.get(api.BRAND_PROTECTION_DEMOGRAPHICS, { ...configJson, params }) }
async function bp_escalation(params) { return ApiIntercepter.get(api.BRAND_PROTECTION_ESCALATION, { ...configJson, params }) }
async function bp_alert_latency(params) { return ApiIntercepter.get(api.BRAND_PROTECTION_ALERT_LATENCY, { ...configJson, params }) }
async function bp_stix_export(params) { return ApiIntercepter.get(api.BRAND_PROTECTION_STIX, { ...configJson, params }) }
async function bp_correlation(params) { return ApiIntercepter.get(api.BRAND_PROTECTION_CORRELATION, { ...configJson, params }) }
function bp_report_url(fmt) { return api.BRAND_PROTECTION_REPORT(fmt); }
async function bp_physical_threats(params) { return ApiIntercepter.get(api.BRAND_PROTECTION_PHYSICAL_THREATS, { ...configJson, params }) }
async function bp_vaccine_initiatives(params) { return ApiIntercepter.get(api.BRAND_PROTECTION_VACCINE_INITIATIVES, { ...configJson, params }) }
async function bp_vaccine_safety_misinfo(params) { return ApiIntercepter.get(api.BRAND_PROTECTION_VACCINE_SAFETY_MISINFO, { ...configJson, params }) }
async function bp_visit_mention(id) { return ApiIntercepter.post(api.BRAND_PROTECTION_VISIT(id), {}, configJson) }
async function bp_unvisit_mention(id) { return ApiIntercepter.delete(api.BRAND_PROTECTION_VISIT(id), configJson) }
async function bp_set_mention_verdict(id, verdict) { return ApiIntercepter.post(api.BRAND_PROTECTION_MENTION_VERDICT(id), { verdict }, configJson) }
async function bp_list_muted_domains() { return ApiIntercepter.get(api.BRAND_PROTECTION_MUTED_DOMAINS, configJson) }
async function bp_mute_domain(body) { return ApiIntercepter.post(api.BRAND_PROTECTION_MUTED_DOMAINS, body, configJson) }
async function bp_unmute_domain(id) { return ApiIntercepter.delete(api.BRAND_PROTECTION_UNMUTE_DOMAIN(id), configJson) }
async function bp_list_mention_tags() { return ApiIntercepter.get(api.BRAND_PROTECTION_MENTION_TAGS, configJson) }
async function bp_create_mention_tag(body) { return ApiIntercepter.post(api.BRAND_PROTECTION_MENTION_TAGS, body, configJson) }
async function bp_delete_mention_tag(id) { return ApiIntercepter.delete(api.BRAND_PROTECTION_MENTION_TAG_DELETE(id), configJson) }
async function bp_apply_mention_tag(mentionId, body) { return ApiIntercepter.post(api.BRAND_PROTECTION_MENTION_TAG_APPLY(mentionId), body, configJson) }
async function bp_unapply_mention_tag(mentionId, body) { return ApiIntercepter.delete(api.BRAND_PROTECTION_MENTION_TAG_APPLY(mentionId), { ...configJson, data: body }) }
async function bp_list_report_queue() { return ApiIntercepter.get(api.BRAND_PROTECTION_REPORT_QUEUE, configJson) }
async function bp_clear_report_queue() { return ApiIntercepter.delete(api.BRAND_PROTECTION_REPORT_QUEUE_CLEAR, configJson) }
async function bp_queue_mention(id, body) { return ApiIntercepter.post(api.BRAND_PROTECTION_MENTION_QUEUE(id), body || {}, configJson) }
async function bp_unqueue_mention(id) { return ApiIntercepter.delete(api.BRAND_PROTECTION_MENTION_QUEUE(id), configJson) }
async function bp_request_mention_takedown(id, body) { return ApiIntercepter.post(api.BRAND_PROTECTION_MENTION_TAKEDOWN(id), body || {}, configJson) }
async function bp_watchlists_get() { return ApiIntercepter.get(api.BRAND_PROTECTION_WATCHLISTS, configJson) }
async function bp_watchlists_put(body) { return ApiIntercepter.put(api.BRAND_PROTECTION_WATCHLISTS, body, configJson) }
async function bp_watchlists_audit(params) { return ApiIntercepter.get(api.BRAND_PROTECTION_WATCHLISTS_AUDIT, { ...configJson, params }) }
async function bp_list_watchlist_entries(params) { return ApiIntercepter.get(api.BRAND_PROTECTION_WATCHLIST_ENTRIES, { ...configJson, params }) }
async function bp_create_watchlist_entry(body) { return ApiIntercepter.post(api.BRAND_PROTECTION_WATCHLIST_ENTRIES, body, configJson) }
async function bp_delete_watchlist_entry(entryId) { return ApiIntercepter.delete(api.BRAND_PROTECTION_WATCHLIST_ENTRY(entryId), configJson) }
async function bp_rescan_mentions() { return ApiIntercepter.post(api.BRAND_PROTECTION_RESCAN_MENTIONS, {}, configJson) }
async function bp_scan_status() { return ApiIntercepter.get(api.BRAND_PROTECTION_SCAN_STATUS, configJson) }
async function bp_mentions_since(params) { return ApiIntercepter.get(api.BRAND_PROTECTION_MENTIONS_SINCE, { ...configJson, params }) }
async function bp_anchor_preview(params) { return ApiIntercepter.get(api.BRAND_PROTECTION_ANCHOR_PREVIEW, { ...configJson, params }) }
async function bp_get_boolean_query() { return ApiIntercepter.get(api.BRAND_PROTECTION_BOOLEAN_QUERY, configJson) }
async function bp_put_boolean_query(body) { return ApiIntercepter.put(api.BRAND_PROTECTION_BOOLEAN_QUERY, body, configJson) }
async function bp_put_scan_cadence(body) { return ApiIntercepter.put(api.BRAND_PROTECTION_SCAN_CADENCE, body, configJson) }
async function bp_serpapi_usage() { return ApiIntercepter.get(api.BRAND_PROTECTION_SERPAPI_USAGE, configJson) }
async function bp_paging_get() { return ApiIntercepter.get(api.BRAND_PROTECTION_PAGING_CONFIG, configJson) }
async function bp_paging_put(body) { return ApiIntercepter.put(api.BRAND_PROTECTION_PAGING_CONFIG, body, configJson) }
async function bp_paging_test(body) { return ApiIntercepter.post(api.BRAND_PROTECTION_PAGING_TEST, body || {}, configJson) }
async function bp_logo_registry_get() { return ApiIntercepter.get(api.BRAND_PROTECTION_LOGO_REGISTRY, configJson) }
async function bp_logo_registry_add(body) { return ApiIntercepter.post(api.BRAND_PROTECTION_LOGO_REGISTRY, body, configJson) }
async function bp_logo_registry_remove(body) { return ApiIntercepter.delete(api.BRAND_PROTECTION_LOGO_REGISTRY, { ...configJson, data: body }) }
async function bp_get_privacy_settings() { return ApiIntercepter.get(api.BRAND_PROTECTION_PRIVACY_SETTINGS, configJson) }
async function bp_put_privacy_settings(body) { return ApiIntercepter.put(api.BRAND_PROTECTION_PRIVACY_SETTINGS, body, configJson) }
async function bp_get_retention_settings(params) { return ApiIntercepter.get(api.BRAND_PROTECTION_RETENTION_SETTINGS, { ...configJson, params }) }
async function bp_put_retention_settings(body) { return ApiIntercepter.put(api.BRAND_PROTECTION_RETENTION_SETTINGS, body, configJson) }


// Admin — integration management (NMT ops surface)
async function admin_integration_providers() { return ApiIntercepter.get(api.ADMIN_INTEGRATION_PROVIDERS, configJson) }
async function admin_vendor_creds_list() { return ApiIntercepter.get(api.ADMIN_VENDOR_CREDS, configJson) }
async function admin_vendor_creds_upsert(body) { return ApiIntercepter.post(api.ADMIN_VENDOR_CREDS, body, configJson) }
async function admin_vendor_creds_patch(id, body) { return ApiIntercepter.patch(api.ADMIN_VENDOR_CREDS_DETAIL(id), body, configJson) }
async function admin_vendor_creds_delete(id) { return ApiIntercepter.delete(api.ADMIN_VENDOR_CREDS_DETAIL(id), configJson) }
async function admin_vendor_creds_test(id) { return ApiIntercepter.post(api.ADMIN_VENDOR_CREDS_TEST(id), {}, configJson) }
async function admin_tenant_entitlements_list(params) { return ApiIntercepter.get(api.ADMIN_TENANT_ENTITLEMENTS, { ...configJson, params }) }
async function admin_tenant_entitlement_upsert(body) { return ApiIntercepter.post(api.ADMIN_TENANT_ENTITLEMENTS, body, configJson) }
async function admin_tenant_entitlement_patch(id, body) { return ApiIntercepter.patch(api.ADMIN_TENANT_ENTITLEMENT_DETAIL(id), body, configJson) }
async function admin_tenant_entitlement_delete(id) { return ApiIntercepter.delete(api.ADMIN_TENANT_ENTITLEMENT_DETAIL(id), configJson) }
async function admin_organizations_list() { return ApiIntercepter.get(api.ADMIN_ORGANIZATIONS, configJson) }


// ── AI Governance helpers ──
// Dedicated client for the AI Governance endpoints so they can later be
// pointed at a separate AI API host via REACT_APP_AI_API_URL. Falls back to
// the shared ApiIntercepter when that env var is unset.
const AIApi = process.env.REACT_APP_AI_API_URL ? SbomApiIntercepter : ApiIntercepter;


async function ai_dashboard() { return AIApi.get(api.AI_DASHBOARD, configJson) }


async function ai_scan(params) { return AIApi.post(api.AI_SCAN, params || {}, configJson) }


async function ai_assets(params) { return AIApi.get(api.AI_ASSETS, { ...configJson, params }) }


async function ai_approve_asset(id, params) { return AIApi.post(api.AI_APPROVE_ASSET(id), params || {}, configJson) }


async function ai_block_asset(id) { return AIApi.post(api.AI_BLOCK_ASSET(id), {}, configJson) }


async function ai_unblock_asset(id) { return AIApi.post(api.AI_UNBLOCK_ASSET(id), {}, configJson) }


async function ai_policies() { return AIApi.get(api.AI_POLICIES, configJson) }


async function ai_policy_create(params) { return AIApi.post(api.AI_POLICY_CREATE, params, configJson) }


async function ai_policy_init_defaults() { return AIApi.post(api.AI_POLICY_INIT_DEFAULTS, {}, configJson) }


async function ai_policy_instantiate_library() { return AIApi.post(api.AI_POLICY_INSTANTIATE_LIBRARY, {}, configJson) }


async function ai_policy_update(id, params) { return AIApi.post(api.AI_POLICY_UPDATE(id), params, configJson) }


async function ai_policy_delete(id) { return AIApi.post(api.AI_POLICY_DELETE(id), {}, configJson) }


async function ai_policy_toggle(id) { return AIApi.post(api.AI_POLICY_TOGGLE(id), {}, configJson) }


async function ai_policy_evaluate_all() { return AIApi.post(api.AI_POLICY_EVALUATE_ALL, {}, configJson) }


async function ai_groups() { return AIApi.get(api.AI_GROUPS, configJson) }


async function ai_group_create(params) { return AIApi.post(api.AI_GROUP_CREATE, params, configJson) }


async function ai_group_update(id, params) { return AIApi.post(api.AI_GROUP_UPDATE(id), params, configJson) }


async function ai_group_delete(id) { return AIApi.post(api.AI_GROUP_DELETE(id), {}, configJson) }


async function ai_ext_fleet() { return AIApi.get(api.AI_EXT_FLEET, configJson) }


async function ai_ext_config() { return AIApi.get(api.AI_EXT_CONFIG, configJson) }


async function ai_ext_config_update(params) { return AIApi.post(api.AI_EXT_CONFIG, params, configJson) }


async function ai_ext_push_config() { return AIApi.post(api.AI_EXT_PUSH_CONFIG, {}, configJson) }


async function ai_ext_regenerate_token() { return AIApi.post(api.AI_EXT_REGENERATE_TOKEN, {}, configJson) }


async function ai_ext_revoke(id) { return AIApi.post(api.AI_EXT_REVOKE(id), {}, configJson) }


async function ai_ext_set_mode(id, mode) { return AIApi.post(api.AI_EXT_SET_MODE(id), { mode }, configJson) }


async function ai_violations(params) { return AIApi.get(api.AI_VIOLATIONS, { ...configJson, params }) }


async function ai_violation_update_status(id, status, note) { return AIApi.post(api.AI_VIOLATION_UPDATE_STATUS(id), { status, note }, configJson) }


async function ai_violations_bulk_status(ids, status) { return AIApi.post(api.AI_VIOLATIONS_BULK_STATUS, { ids, status }, configJson) }


async function ai_signatures() { return AIApi.get(api.AI_SIGNATURES, configJson) }


async function ai_load_default_signatures() { return AIApi.post(api.AI_SIGNATURES_LOAD_DEFAULTS, {}, configJson) }


async function ai_compliance_evaluate() { return AIApi.post(api.AI_COMPLIANCE_EVALUATE, {}, configJson) }


async function ai_compliance_scores() { return AIApi.get(api.AI_COMPLIANCE_SCORES, configJson) }


async function ai_frameworks() { return AIApi.get(api.AI_FRAMEWORKS, configJson) }


async function ai_framework_detail(id) { return AIApi.get(api.AI_FRAMEWORK_DETAIL(id), configJson) }


async function ai_framework_create(payload) { return AIApi.post(api.AI_FRAMEWORK_CREATE, payload, configJson) }


async function ai_framework_clone(id, payload) { return AIApi.post(api.AI_FRAMEWORK_CLONE(id), payload || {}, configJson) }


async function ai_framework_update(id, payload) { return AIApi.post(api.AI_FRAMEWORK_UPDATE(id), payload, configJson) }


async function ai_framework_delete(id) { return AIApi.post(api.AI_FRAMEWORK_DELETE(id), {}, configJson) }


async function ai_framework_control_create(id, payload) { return AIApi.post(api.AI_FRAMEWORK_CONTROL_CREATE(id), payload, configJson) }


async function ai_control_update(id, payload) { return AIApi.post(api.AI_CONTROL_UPDATE(id), payload, configJson) }


async function ai_control_delete(id) { return AIApi.post(api.AI_CONTROL_DELETE(id), {}, configJson) }


async function ai_evaluator_catalog() { return AIApi.get(api.AI_EVALUATOR_CATALOG, configJson) }


async function ai_control_evidence(controlRef, limit) {
    return AIApi.get(api.AI_CONTROL_EVIDENCE_LIST, { ...configJson, params: { control_ref: controlRef, ...(limit ? { limit } : {}) } });
}


async function ai_control_evidence_upload(formData) {
    // formData is a FormData instance — handles both file uploads and plain payloads.
    // axios infers Content-Type from the FormData boundary; do not set it manually.
    return AIApi.post(api.AI_CONTROL_EVIDENCE_UPLOAD, formData, configJson);
}


async function ai_policy_suggest_refs(policyId) {
    return AIApi.get(api.AI_POLICY_SUGGEST_REFS(policyId), configJson);
}


async function ai_policy_suggest_refs_bulk(includeAlreadyWired) {
    return AIApi.post(api.AI_POLICY_SUGGEST_REFS_BULK, { include_already_wired: !!includeAlreadyWired }, configJson);
}


async function ai_signature_create(payload) { return AIApi.post(api.AI_SIGNATURE_CREATE, payload, configJson) }


async function ai_signature_update(id, payload) { return AIApi.post(api.AI_SIGNATURE_UPDATE(id), payload, configJson) }


async function ai_signature_delete(id) { return AIApi.post(api.AI_SIGNATURE_DELETE(id), {}, configJson) }


async function ai_signatures_suggested(limit) { return AIApi.get(api.AI_SIGNATURES_SUGGESTED, { ...configJson, params: limit ? { limit } : {} }) }


async function ai_signatures_accept(accepted) { return AIApi.post(api.AI_SIGNATURES_ACCEPT, { accepted }, configJson) }


async function ai_signatures_review(limit) { return AIApi.get(api.AI_SIGNATURES_REVIEW, { ...configJson, params: limit ? { limit } : {} }) }


async function ai_signatures_bulk_import(payload) { return AIApi.post(api.AI_SIGNATURES_BULK_IMPORT, payload, configJson) }


async function ai_groups_active_users(params) { return AIApi.get(api.AI_GROUPS_ACTIVE_USERS, { ...configJson, params: params || {} }) }


async function ai_persons_merge(primary_email, secondary_email) { return AIApi.post(api.AI_PERSONS_MERGE, { primary_email, secondary_email }, configJson) }


async function ai_list_vendor_profiles() {
    return AIApi.get(api.AI_VENDOR_PROFILES, configJson);
}


async function ai_load_vendor_coverage(vendor, params = {}) {
    const qs = new URLSearchParams(params).toString();
    const url = api.AI_VENDOR_COVERAGE(vendor) + (qs ? `?${qs}` : '');
    return AIApi.get(url, configJson);
}


async function ai_load_vendor_coverage_config(vendor) {
    return AIApi.get(api.AI_VENDOR_COVERAGE_CONFIG(vendor), configJson);
}


async function ai_save_vendor_coverage_config(vendor, patch) {
    return AIApi.post(api.AI_VENDOR_COVERAGE_CONFIG(vendor), patch, configJson);
}


async function ai_bulk_seed_vendor_members(vendor, members) {
    return AIApi.post(api.AI_VENDOR_COVERAGE_BULK_SEED(vendor), { members }, configJson);
}


async function ai_list_vendor_enrollment(vendor) {
    return AIApi.get(api.AI_VENDOR_ENROLLMENT(vendor), configJson);
}


async function ai_create_vendor_enrollment(vendor, payload) {
    return AIApi.post(api.AI_VENDOR_ENROLLMENT(vendor), payload, configJson);
}


async function ai_cancel_vendor_enrollment(vendor, id) {
    return AIApi.post(api.AI_VENDOR_ENROLLMENT_CANCEL(vendor, id), {}, configJson);
}


async function ai_sweep_vendor_enrollment(vendor) {
    return AIApi.post(api.AI_VENDOR_ENROLLMENT_SWEEP(vendor), {}, configJson);
}


async function ai_load_link_reviews(params = {}) {
    const qs = new URLSearchParams({
        status: params.status || 'pending',
        page: String(params.page || 1),
        page_size: String(params.page_size || 25),
    }).toString();
    return AIApi.get(`${api.AI_PERSONS_LINK_REVIEWS}?${qs}`, configJson);
}


async function ai_approve_link_review(id, decision_notes = '') {
    return AIApi.post(api.AI_PERSONS_LINK_REVIEW_APPROVE(id), { decision_notes }, configJson);
}


async function ai_reject_link_review(id, decision_notes = '') {
    return AIApi.post(api.AI_PERSONS_LINK_REVIEW_REJECT(id), { decision_notes }, configJson);
}


async function ai_load_cost_advisor_config() { return AIApi.get(api.AI_COST_ADVISOR_CONFIG, configJson) }


async function ai_upsert_cost_advisor_config(payload) { return AIApi.post(api.AI_COST_ADVISOR_CONFIG_UPSERT, payload, configJson) }


async function ai_delete_cost_advisor_config(id) { return AIApi.delete(api.AI_COST_ADVISOR_CONFIG_DELETE(id), configJson) }


async function ai_claim_extension_device(device_id, user_email) { return AIApi.post(api.AI_EXT_DEVICE_CLAIM, { device_id, user_email }, configJson) }


async function ai_dsar_requests(params) { return AIApi.get(api.AI_DSAR_REQUESTS, { ...configJson, params: params || {} }) }


async function ai_dsar_request_create(payload) { return AIApi.post(api.AI_DSAR_REQUEST_CREATE, payload, configJson) }


async function ai_dsar_request_detail(id) { return AIApi.get(api.AI_DSAR_REQUEST_DETAIL(id), configJson) }


async function ai_dsar_request_complete(id, payload) { return AIApi.post(api.AI_DSAR_REQUEST_COMPLETE(id), payload || {}, configJson) }


async function ai_dsar_task_execute(reqId, taskId, payload) { return AIApi.post(api.AI_DSAR_TASK_EXECUTE(reqId, taskId), payload || {}, configJson) }


function ai_dsar_audit_packet_url(id) { return api.AI_DSAR_REQUEST_PACKET(id); }


async function ai_bias_audits(params) { return AIApi.get(api.AI_BIAS_AUDITS, { ...configJson, params: params || {} }) }


async function ai_bias_audit_create(payload) { return AIApi.post(api.AI_BIAS_AUDIT_CREATE, payload, configJson) }


async function ai_bias_audit_detail(id) { return AIApi.get(api.AI_BIAS_AUDIT_DETAIL(id), configJson) }


function ai_bias_audit_report_url(id) { return api.AI_BIAS_AUDIT_REPORT(id); }


async function ai_red_team_prompts(params) { return AIApi.get(api.AI_RED_TEAM_PROMPTS, { ...configJson, params: params || {} }) }


async function ai_red_team_prompt_create(payload) { return AIApi.post(api.AI_RED_TEAM_PROMPT_CREATE, payload, configJson) }


async function ai_red_team_prompt_delete(id) { return AIApi.post(api.AI_RED_TEAM_PROMPT_DELETE(id), {}, configJson) }


async function ai_red_team_runs(params) { return AIApi.get(api.AI_RED_TEAM_RUNS, { ...configJson, params: params || {} }) }


async function ai_red_team_run_start(payload) { return AIApi.post(api.AI_RED_TEAM_RUN_START, payload, configJson) }


async function ai_red_team_run_detail(id) { return AIApi.get(api.AI_RED_TEAM_RUN_DETAIL(id), configJson) }


async function ai_red_team_run_cancel(id) { return AIApi.post(api.AI_RED_TEAM_RUN_CANCEL(id), {}, configJson) }


function ai_red_team_run_report_url(id) { return api.AI_RED_TEAM_RUN_REPORT(id); }


async function ai_signatures_expand(targetCount, focusCategory) {
    const body = { target_count: targetCount || 30 };
    if (focusCategory) body.focus_category = focusCategory;
    return AIApi.post(api.AI_SIGNATURES_EXPAND, body, configJson);
}


async function ai_assess_all() { return AIApi.post(api.AI_RISK_ASSESS_ALL, {}, configJson) }


async function ai_risk_scores() { return AIApi.get(api.AI_RISK_SCORES, configJson) }


async function ai_dlp_events(params) { return AIApi.get(api.AI_DLP_EVENTS, { ...configJson, params }) }


async function ai_dlp_event_patterns(params) { return AIApi.get(api.AI_DLP_EVENT_PATTERNS, { ...configJson, params }) }


async function ai_policy_dry_run(body) { return AIApi.post(api.AI_POLICY_DRY_RUN, body, configJson) }


async function ai_dlp_anomalies(params) { return AIApi.get(api.AI_DLP_ANOMALIES, { ...configJson, params }) }


async function ai_saved_searches() { return AIApi.get(api.AI_SAVED_SEARCHES, configJson) }


async function ai_saved_search_create(body) { return AIApi.post(api.AI_SAVED_SEARCH_CREATE, body, configJson) }


async function ai_saved_search_run(id) { return AIApi.post(api.AI_SAVED_SEARCH_RUN, { id }, configJson) }


async function ai_saved_search_delete(ssid) { return AIApi.delete(api.AI_SAVED_SEARCH_DELETE(ssid), configJson) }


async function ai_sev_topics() { return AIApi.get(api.AI_SEV_TOPICS, configJson) }


async function ai_sev_presets() { return AIApi.get(api.AI_SEV_PRESETS, configJson) }


async function ai_sev_overrides() { return AIApi.get(api.AI_SEV_OVERRIDES, configJson) }


async function ai_sev_override_set(body) { return AIApi.post(api.AI_SEV_OVERRIDE_SET, body, configJson) }


async function ai_sev_override_delete(topic) { return AIApi.delete(api.AI_SEV_OVERRIDE_DELETE(topic), configJson) }


async function ai_sev_apply_preset(preset_key) { return AIApi.post(api.AI_SEV_APPLY_PRESET, { preset_key }, configJson) }


async function ai_integration_adapters() { return AIApi.get(api.AI_INTEGRATION_ADAPTERS, configJson) }


async function ai_event_set_status(eid, body) { return AIApi.post(api.AI_DLP_EVENT_STATUS(eid), body, configJson) }


async function ai_event_assign(eid, assignee_id) { return AIApi.post(api.AI_DLP_EVENT_ASSIGN(eid), { assignee_id }, configJson) }


async function ai_event_comments_get(eid) { return AIApi.get(api.AI_DLP_EVENT_COMMENTS(eid), configJson) }


async function ai_event_comment_add(eid, body) { return AIApi.post(api.AI_DLP_EVENT_COMMENTS(eid), { body }, configJson) }


async function ai_org_users() { return AIApi.get(api.AI_ORG_USERS, configJson) }


async function ai_siem_forwarders() { return AIApi.get(api.AI_SIEM_FORWARDERS, configJson) }


async function ai_siem_forwarder_create(body) { return AIApi.post(api.AI_SIEM_FORWARDER_CREATE, body, configJson) }


async function ai_siem_forwarder_toggle(fid) { return AIApi.post(api.AI_SIEM_FORWARDER_TOGGLE(fid), {}, configJson) }


async function ai_siem_forwarder_delete(fid) { return AIApi.delete(api.AI_SIEM_FORWARDER_DELETE(fid), configJson) }


async function ai_siem_forwarder_test(fid) { return AIApi.post(api.AI_SIEM_FORWARDER_TEST(fid), {}, configJson) }


async function ai_dlp_summary(hours) { return AIApi.get(api.AI_DLP_SUMMARY(hours), configJson) }


async function ai_dlp_integrations() { return AIApi.get(api.AI_DLP_INTEGRATIONS, configJson) }


async function loadDLPDashboard({ hours = 24, vendor, page_size } = {}) {
    const { unwrap } = await import('./HelperMethod/aigEnvelope');
    const eventParams = {};
    if (vendor) eventParams.vendor = vendor;
    if (page_size) eventParams.page_size = page_size;
    const [eventsRes, summaryRes] = await Promise.all([
        ai_dlp_events(eventParams),
        ai_dlp_summary(hours),
    ]);
    return {
        events: unwrap(eventsRes)?.events || [],
        summary: unwrap(summaryRes) || null,
    };
}


async function ai_dlp_create_integration(params) { return AIApi.post(api.AI_DLP_CREATE_INTEGRATION, params, configJson) }


async function ai_dlp_update_integration(id, params) { return AIApi.post(api.AI_DLP_UPDATE_INTEGRATION(id), params, configJson) }


async function ai_dlp_toggle_integration(id) { return AIApi.post(api.AI_DLP_TOGGLE_INTEGRATION(id), {}, configJson) }


async function ai_dlp_poll_integration(id) { return AIApi.post(api.AI_DLP_POLL_INTEGRATION(id), {}, configJson) }


async function ai_dlp_poll_all() { return AIApi.post(api.AI_DLP_POLL_ALL, {}, configJson) }


async function ai_policy_gen_list() { return AIApi.get(api.AI_POLICY_GEN_LIST, configJson) }


async function ai_policy_gen_get(id) { return AIApi.get(api.AI_POLICY_GEN_DETAIL(id), configJson) }


async function ai_generate_policy(payload) { return AIApi.post(api.AI_POLICY_GEN_GENERATE, payload || {}, configJson) }


async function ai_policy_gen_sign(id) { return AIApi.post(api.AI_POLICY_GEN_SIGN(id), {}, configJson) }


async function ai_whitelist() { return AIApi.get(api.AI_WHITELIST, configJson) }


async function ai_whitelist_add(params) { return AIApi.post(api.AI_WHITELIST_ADD, params, configJson) }


async function ai_whitelist_remove(id) { return AIApi.delete(api.AI_WHITELIST_REMOVE(id), configJson) }


async function ai_enforcement_integrations() { return AIApi.get(api.AI_ENFORCEMENT_INTEGRATIONS, configJson) }


async function ai_enforcement_save(params) { return AIApi.post(api.AI_ENFORCEMENT_SAVE, params, configJson) }


async function ai_enforcement_delete(params) { return AIApi.post(api.AI_ENFORCEMENT_DELETE, params, configJson) }


async function ai_enforcement_test(params) { return AIApi.post(api.AI_ENFORCEMENT_TEST, params, configJson) }


async function ai_user_profiles() { return AIApi.get(api.AI_USER_PROFILES, configJson) }


async function ai_detection_sources() { return AIApi.get(api.AI_DETECTION_SOURCES, configJson) }


async function ai_recompute() { return AIApi.post(api.AI_RECOMPUTE, {}, configJson) }


async function ai_options() { return AIApi.get(api.AI_OPTIONS, configJson) }


async function ai_blocklist_export(format, scope) { return AIApi.get(api.AI_BLOCKLIST_EXPORT(format, scope), { ...configJson, responseType: 'text' }) }


async function ai_blocklist_formats() { return AIApi.get(api.AI_BLOCKLIST_FORMATS, configJson) }


async function audit_log(params) { return AIApi.get(api.AI_AUDIT_LOG, { ...configJson, params }) }


async function ai_schedules() { return AIApi.get(api.AI_SCHEDULES, configJson) }


async function ai_schedule_create(params) { return AIApi.post(api.AI_SCHEDULE_CREATE, params, configJson) }


async function ai_schedule_toggle(id) { return AIApi.post(api.AI_SCHEDULE_TOGGLE(id), {}, configJson) }


async function ai_schedule_delete(id) { return AIApi.delete(api.AI_SCHEDULE_DELETE(id), configJson) }


async function ai_v2_load_tenant_nodes(params) { return AIApi.get(api.AI_V2_TENANT_NODES, { ...configJson, params }) }


async function ai_v2_load_tenant_nodes_diagnostic() { return AIApi.get(api.AI_V2_TENANT_NODES_DIAGNOSTIC, configJson) }


async function ai_v2_seed_tenant_root() { return AIApi.post(api.AI_V2_TENANT_NODES_SEED_ROOT, {}, configJson) }


async function ai_v2_load_org_profiles(params) { return AIApi.get(api.AI_V2_ORG_PROFILE, { ...configJson, params }) }


async function ai_v2_ai_create_org_profile(params) { return AIApi.post(api.AI_V2_ORG_PROFILE, params, configJson) }


async function ai_v2_ai_generate_framework_recommendation(params) { return AIApi.post(api.AI_V2_FRAMEWORK_AI_RECOMMEND, params || {}, configJson) }


async function ai_v2_load_framework_catalog(params) { return AIApi.get(api.AI_V2_FRAMEWORKS_CATALOG, { ...configJson, params }) }


async function ai_v2_get_framework(id) { return AIApi.get(api.AI_V2_FRAMEWORK_DETAIL(id), configJson) }


async function ai_v2_activate_framework_recommendation(id, params) { return AIApi.post(api.AI_V2_FRAMEWORK_ACCEPT(id), params || {}, configJson) }


async function ai_v2_load_policies(params) { return AIApi.get(api.AI_V2_POLICIES, { ...configJson, params }) }


async function ai_v2_transition_policy_mode(id, params) { return AIApi.post(api.AI_V2_POLICY_TRANSITION_MODE(id), params, configJson) }


async function ai_v2_bulk_activate_policies(payload) { return AIApi.post(api.AI_V2_POLICY_BULK_ACTIVATE, payload, configJson) }


async function ai_v2_bulk_transition_policies(payload) { return AIApi.post(api.AI_V2_POLICY_BULK_TRANSITION, payload, configJson) }


async function ai_v2_bindings_matrix() { return AIApi.get(api.AI_V2_POLICY_BINDINGS_MATRIX, configJson) }


async function ai_v2_policy_binding_create(policyId, payload) { return AIApi.post(api.AI_V2_POLICY_BINDINGS(policyId), payload, configJson) }


async function ai_v2_policy_binding_delete(policyId, bindingId) { return AIApi.post(api.AI_V2_POLICY_BINDING_DELETE(policyId, bindingId), {}, configJson) }


async function ai_v2_policy_binding_transition(policyId, bindingId, payload) { return AIApi.post(api.AI_V2_POLICY_BINDING_TRANSITION(policyId, bindingId), payload, configJson) }


async function ai_v2_endpoint_bindings_matrix() { return AIApi.get(api.AI_V2_POLICY_EP_BINDINGS_MATRIX, configJson) }


async function ai_v2_policy_endpoint_binding_create(policyId, payload) { return AIApi.post(api.AI_V2_POLICY_EP_BINDINGS(policyId), payload, configJson) }


async function ai_v2_policy_endpoint_binding_delete(policyId, bindingId) { return AIApi.post(api.AI_V2_POLICY_EP_BINDING_DELETE(policyId, bindingId), {}, configJson) }


async function ai_v2_policy_endpoint_binding_transition(policyId, bindingId, p) { return AIApi.post(api.AI_V2_POLICY_EP_BINDING_TRANSITION(policyId, bindingId), p, configJson) }


async function ai_v2_load_dashboard_summary(params) { return AIApi.get(api.AI_V2_POLICY_DASHBOARD_SUMMARY, { ...configJson, params }) }


async function ai_v2_load_idp_integrations() { return AIApi.get(api.AI_V2_IDP_INTEGRATIONS, configJson) }


async function ai_v2_create_idp_integration(payload) { return AIApi.post(api.AI_V2_IDP_INTEGRATIONS, payload, configJson) }


async function ai_v2_update_idp_integration(id, payload) { return AIApi.patch(api.AI_V2_IDP_INTEGRATION_DETAIL(id), payload, configJson) }


async function ai_v2_delete_idp_integration(id) { return AIApi.delete(api.AI_V2_IDP_INTEGRATION_DETAIL(id), configJson) }


async function ai_v2_test_idp_integration(id) { return AIApi.post(api.AI_V2_IDP_INTEGRATION_TEST(id), {}, configJson) }


async function ai_v2_sync_now_idp_integration(id) { return AIApi.post(api.AI_V2_IDP_INTEGRATION_SYNC_NOW(id), {}, configJson) }


async function ai_v2_load_gateway_keys() { return AIApi.get(api.AI_V2_LLM_GATEWAY_KEYS, configJson) }


async function ai_v2_create_gateway_key(payload) {
    // Widen validateStatus so 409 (duplicate) comes through as a normal response
    // rather than throwing. The caller inspects the envelope for `duplicate:true`
    // and renders a targeted "already exists" state instead of a generic error.
    return AIApi.post(api.AI_V2_LLM_GATEWAY_KEYS, payload, {
        ...configJson,
        validateStatus: s => (s >= 200 && s < 300) || s === 409,
    });
}


async function ai_v2_revoke_gateway_key(id) { return AIApi.post(api.AI_V2_LLM_GATEWAY_KEY_REVOKE(id), {}, configJson) }


async function ai_v2_load_gateway_usage() { return AIApi.get(api.AI_V2_LLM_GATEWAY_USAGE, configJson) }


async function ai_v2_load_gateway_recent() { return AIApi.get(api.AI_V2_LLM_GATEWAY_RECENT, configJson) }


async function ai_v2_load_gateway_vendor_creds() { return AIApi.get(api.AI_V2_LLM_GATEWAY_VENDOR_CREDS, configJson) }


async function ai_v2_upsert_gateway_vendor_cred(p) { return AIApi.post(api.AI_V2_LLM_GATEWAY_VENDOR_CREDS, p, configJson) }


async function ai_v2_delete_gateway_vendor_cred(id) { return AIApi.delete(api.AI_V2_LLM_GATEWAY_VENDOR_CRED_DEL(id), configJson) }


async function ai_v2_load_gateway_budget_alerts() { return AIApi.get(api.AI_V2_LLM_GATEWAY_BUDGET_ALERTS, configJson) }


async function ai_v2_upsert_gateway_budget_alerts(p) {
    return AIApi.post(api.AI_V2_LLM_GATEWAY_BUDGET_ALERTS, p, {
        ...configJson,
        // 400 comes back with a structured payload naming which recipients were rejected —
        // widen validateStatus so the caller can surface the message inline instead of via catch.
        validateStatus: s => (s >= 200 && s < 300) || s === 400,
    });
}


async function ai_v2_test_gateway_budget_alert() { return AIApi.post(api.AI_V2_LLM_GATEWAY_BUDGET_ALERTS_TEST, {}, configJson) }


async function ai_v2_send_gateway_budget_report() { return AIApi.post(api.AI_V2_LLM_GATEWAY_BUDGET_ALERTS_REPORT, {}, configJson) }


async function ai_v2_load_gateway_budget() { return AIApi.get(api.AI_V2_LLM_GATEWAY_BUDGET, configJson) }


async function ai_v2_upsert_gateway_budget(payload) { return AIApi.post(api.AI_V2_LLM_GATEWAY_BUDGET_UPSERT, payload, configJson) }


async function ai_v2_delete_gateway_budget(id) { return AIApi.post(api.AI_V2_LLM_GATEWAY_BUDGET_DELETE, { id }, configJson) }


async function ai_v2_load_coverage_posture() { return AIApi.get(api.AI_V2_COVERAGE_POSTURE, configJson) }


async function ai_v2_load_budget_breakdown(params) { return AIApi.get(api.AI_V2_LLM_GATEWAY_BUDGET_BREAKDOWN, { ...configJson, params }) }


async function ai_v2_load_cost_advisor(params) { return AIApi.get(api.AI_V2_LLM_GATEWAY_COST_ADVISOR, { ...configJson, params }) }


async function ai_v2_bulk_issue_gateway_keys(body) { return AIApi.post(api.AI_V2_LLM_GATEWAY_BULK_ISSUE, body, configJson) }


async function ai_load_ai_categories() { return AIApi.get(api.AI_AI_CATEGORIES, configJson) }


async function ai_v2_load_evidence(params) { return AIApi.get(api.AI_V2_EVIDENCE, { ...configJson, params }) }


async function ai_v2_fetch_evidence_payload(id) { return AIApi.get(api.AI_V2_EVIDENCE_PAYLOAD(id), configJson) }


async function ai_v2_verify_evidence(id) { return AIApi.get(api.AI_V2_EVIDENCE_VERIFY(id), configJson) }


async function ai_v2_load_auditor_tokens(params) { return AIApi.get(api.AI_V2_AUDITOR_TOKENS, { ...configJson, params }) }


async function ai_v2_issue_auditor_token(params) { return AIApi.post(api.AI_V2_AUDITOR_TOKEN_ISSUE, params, configJson) }


async function ai_v2_revoke_auditor_token(id) { return AIApi.post(api.AI_V2_AUDITOR_TOKEN_REVOKE(id), {}, configJson) }


async function ai_v2_load_response_evals(params) { return AIApi.get(api.AI_V2_RESPONSE_EVAL, { ...configJson, params }) }


async function ai_v2_get_response_eval(id) { return AIApi.get(api.AI_V2_RESPONSE_EVAL_DETAIL(id), configJson) }


async function ai_v2_load_response_eval_summary(params) { return AIApi.get(api.AI_V2_RESPONSE_EVAL_SUMMARY, { ...configJson, params }) }


async function ai_v2_load_framework_scores_heatmap(params) { return AIApi.get(api.AI_V2_FRAMEWORK_SCORES_HEATMAP, { ...configJson, params }) }


async function ai_v2_load_policy_scores_ranked(params) { return AIApi.get(api.AI_V2_POLICY_SCORES_RANKED, { ...configJson, params }) }


async function ai_v2_load_sentiment_trends_heatmap(params) { return AIApi.get(api.AI_V2_SENTIMENT_TRENDS_HEATMAP, { ...configJson, params }) }


async function ai_v2_load_sentiment_trends_anomalies(params) { return AIApi.get(api.AI_V2_SENTIMENT_TRENDS_ANOMALIES, { ...configJson, params }) }


async function ai_v2_load_ext_mdm_catalog() { return AIApi.get(api.AI_V2_EXT_MDM_CATALOG, configJson) }


async function ai_v2_issue_ext_enrollment(params) { return AIApi.post(api.AI_V2_EXT_MDM_ISSUE, params, configJson) }


async function ai_load_agent_traces(params) { return AIApi.get(api.AI_V2_AGENT_TRACES, { ...configJson, params }) }


async function ai_load_agent_trace_detail(id) { return AIApi.get(api.AI_V2_AGENT_TRACE_DETAIL(id), configJson) }


async function ai_load_agent_trace_summary(params) { return AIApi.get(api.AI_V2_AGENT_TRACE_SUMMARY, { ...configJson, params }) }


async function ai_load_cost_advisor_top_spenders(params) { return AIApi.get(api.AI_V2_COST_ADVISOR_TOP_SPENDERS, { ...configJson, params }) }


async function ai_load_cost_advisor_by_group(params) { return AIApi.get(api.AI_V2_COST_ADVISOR_BY_GROUP, { ...configJson, params }) }


function ai_v2_ext_mdm_download_url(platform, params = {}) {
    const qs = new URLSearchParams(params).toString();
    const map = {
        chrome: api.AI_V2_EXT_MDM_CHROME,
        edge: api.AI_V2_EXT_MDM_EDGE,
        intune_macos: api.AI_V2_EXT_MDM_INTUNE_MACOS,
        intune_windows: api.AI_V2_EXT_MDM_INTUNE_WINDOWS,
        jamf: api.AI_V2_EXT_MDM_JAMF,
        schema: api.AI_V2_EXT_MDM_SCHEMA,
    };
    const base = map[platform];
    return base ? (qs ? `${base}?${qs}` : base) : null;
}



export {
    getOrganizationAssessmentSettingsService,
    updateOrganizationAssessmentSettingsService,
    reviewResponseService,
    updateAssessmentReviewStatusService,
    uploadVendorDocumentsService,
    uploadVendorResponseDocumentsService,
    deleteVendorResponseDocumentsService,
    getVendorResponseDocumentService,
    getVendorQuestionSuggestionsService,
    getAssessmentDetailsService,
    getAssessmentResponsesService,
    getAssessmentResponseDocumentService,
    submitVendorAssessmentService,
    getVendorAssessmentService,
    getTprmAssessmentCategoriesService,
    createTprmAssessmentService,
    getTprmAssessmentsService,
    deleteThirdpartyQuestionsService,
    getThirdpartyQuestionsTemplateService,
    bulkUploadThirdpartyQuestionsService,
    editThirdpartyQuestionsService,
    createThirdpartyQuestionsService,
    thirdpartyExternalExposureQuestionsService,
    request_evidence_exception,
    bulk_request_exception,
    get_bank_list,
    add_bank,
    invite_banks,
    bank_signup,
    frameworkComplianceMappingService,
    compliance_domains,
    website_whats_new,
    scanner_notifications,
    organizationComplianceReportService,
    organizationComplianceSubmissionService,
    getOrganizationComplianceSubmissionService,
    setDraftStatusService,
    downloadScannerReportService,
    sharingQuetionService,
    deleteQuestionSharingService,
    donainComplianceReportService,
    domainControlsService,
    domainControlsQuestionsService,
    overallComplianceReportService,
    complianceFrameworksService,
    ownerBaseComplianceReportService,
    send_otp,
    sign_up,
    sign_in,
    login_verify_otp,
    login_resend_otp,
    sso_exchange_code,
    sso_discover,
    sso_logout,
    forgot_password,
    verify_otp_reset,
    reset_password,
    update_user_profile,
    getUserPlanInfoService,
    getUserProfileService,
    getAuthMetadataService,
    frameworkComplianceService,

    // Exposure Map
    scanner_domain_results,
    scanner_scan_history_summary,
    scanner_scan_history,
    scanner_scan_history_compare,
    scanner_issue_details,
    download_evidence_csv,
    generate_executive_pdf,
    logout,
    refreshToken,
    organization_domain,
    toggle_blacklist,
    toggle_popup,
    domain_addition_request,
    assest_management,
    change_password,

    // translation to english
    bp_translate_mention,
    bp_mention_comments,

    // AI
    send_ai_query,
    chatbot_initialize,
    delete_session,

    // Findings
    findings_solution_details,
    category_finding,

    // Org Members
    getReportEmailRecipients,
    addReportEmailRecipient,
    updateReportEmailRecipient,
    deleteReportEmailRecipient,
    getOrgMembers,
    addOrgMember,
    updateOrgMember,
    deleteOrgMember,

    // Platform Users
    getPlatformUsers,
    addPlatformUser,

    // Role Assignments
    assignRoleToUser,
    unassignRoleFromUser,

    // Plan Management
    getPlans,
    createPlan,
    updatePlan,
    deletePlan,

    // Org Plan Allocation
    getOrgPlanAllocation,
    assignOrgPlan,
    addOrgTrialDays,

    // Permissions
    getAvailablePermissions,

    // Risk Registry
    add_new_risk,
    total_risk_created,
    risk_by_stats,
    risk_by_severity,
    risk_download,
    bulk_upload_risk_registry,
    download_risk_registry_template,
    send_risk_notification,
    download_vendor_template,
    download_cxo_report,
    add_on_service,
    list_all_risk,
    delete_risk,
    get_by_id_risk,
    edit_by_id_risk_registry,
    update_risk_registry,

    // Vendor/Third party
    add_new_vendor_name,
    metaData,
    get_all_thirdparty_domain,
    delete_by_id_thirdparty_domain,
    get_by_id_third_party,
    edit_by_id_third_party,
    vendors_by_business_impact_graph,
    vendors_positive_negative_trend,
    third_party_download,
    third_party_monitored_vendors,
    vendors_with_incidents,
    vendors_with_critical_business_impact,
    show_vendors_details_data,
    send_invitation_to_vendor,
    bulk_upload_vendors,

    // easm
    bp_ai_review_posts,
    load_takedowns_list,
    load_takedown_sla_metrics,
    load_brand_watchlist,
    ai_generate_brand_watchlist_defaults,
    create_brand_watchlist_entry,
    delete_brand_watchlist_entry,
    bulk_upsert_brand_watchlist,

    // Vulnerality Management
    get_agents_vm_data,
    get_vulnerabilities_data,
    show_vulnerabilities_details_data,
    track_vm_graph_data,
    download_vm_excel_sheet,
    user_region,

    // SBOM
    sbom_dashboard,
    sbom_list_reports,
    sbom_report_detail,
    sbom_generate,
    sbom_upload,
    sbom_list_components,
    sbom_component_detail,
    sbom_component_tree,
    sbom_impact_search,
    sbom_license_summary,
    sbom_drift_logs,
    sbom_export_report,
    sbom_agents,
    sbom_scan_ssh,
    sbom_scan_cloud,
    sbom_setup_snippets,
    sbom_vex_create,
    sbom_vex_list,
    sbom_vex_export,
    sbom_policies,
    sbom_policy_create,
    sbom_policy_toggle,
    sbom_policy_delete,
    sbom_policy_init_defaults,
    sbom_policy_evaluate,
    sbom_violations,
    sbom_export_pdf,
    sbom_export_html,
    sbom_ingest_agent,
    sbom_ci_cd_webhook,
    sbom_enrich_report,
    sbom_enrich_licenses,
    sbom_enrich_licenses_all,
    sbom_diff,
    sbom_versions,
    sbom_risk_trend,
    sbom_risk_snapshot,
    sbom_dashboard_enhanced,
    sbom_compliance_evaluate,
    sbom_compliance_scores,
    sbom_schedules,
    sbom_schedule_create,
    sbom_schedule_toggle,
    sbom_schedule_delete,
    sbom_audit_log,
    load_correlated_signals,
    create_takedown_request_from_finding,
    // Brand Protection
    bp_mentions,
    bp_mentions_dropped,
    bp_mention_mark_relevant,
    bp_topics,
    bp_chart,
    bp_sentiment,
    bp_influencers,
    bp_sources,
    bp_filters,
    bp_undiscovered_sources,
    bp_assistant_ask,
    bp_visit_mention,
    bp_unvisit_mention,
    bp_mute_domain,
    bp_unmute_domain,
    bp_set_mention_verdict,
    bp_list_mention_tags,
    bp_create_mention_tag,
    bp_delete_mention_tag,
    bp_apply_mention_tag,
    bp_unapply_mention_tag,
    bp_list_report_queue,
    bp_clear_report_queue,
    bp_queue_mention,
    bp_unqueue_mention,
    bp_request_mention_takedown,
    bp_rescan_mentions,
    bp_scan_status,
    bp_mentions_since,
    bp_anchor_preview,
    bp_alert_latency,
    bp_demographics,
    bp_watchlists_get,
    bp_watchlists_put,
    bp_watchlists_audit,
    bp_list_watchlist_entries,
    bp_create_watchlist_entry,
    bp_delete_watchlist_entry,
    bp_paging_get,
    bp_paging_put,
    bp_paging_test,
    bp_logo_registry_get,
    bp_logo_registry_add,
    bp_logo_registry_remove,
    bp_get_boolean_query,
    bp_put_boolean_query,
    bp_put_scan_cadence,
    bp_serpapi_usage,
    bp_physical_threats,
    bp_vaccine_initiatives,
    bp_vaccine_safety_misinfo,
    bp_stix_export,
    bp_correlation,
    bp_escalation,
    bp_report_url,
    bp_resolve_avatar,
    bp_list_muted_domains,
    bp_get_privacy_settings,
    bp_put_privacy_settings,
    bp_get_retention_settings,
    bp_put_retention_settings,


    // Admin — integration management
    admin_integration_providers,
    admin_vendor_creds_list,
    admin_vendor_creds_upsert,
    admin_vendor_creds_patch,
    admin_vendor_creds_delete,
    admin_vendor_creds_test,
    admin_tenant_entitlements_list,
    admin_tenant_entitlement_upsert,
    admin_tenant_entitlement_patch,
    admin_tenant_entitlement_delete,
    admin_organizations_list,

    // AI Governance
    aig_dashboard,
    aig_scan,
    aig_assets,
    aig_shadow_assets,
    aig_approve_asset,
    aig_block_asset,
    aig_classify_asset,
    aig_policies,
    aig_policy_create,
    aig_policy_init_defaults,
    aig_violations,
    aig_signatures,
    aig_load_signatures,
    aig_trends,
    aig_trends_snapshot,
    aig_compliance_evaluate,
    aig_compliance_scores,
    aig_assess_all,
    aig_risk_scores,
    aig_dlp_events,
    aig_dlp_summary,
    aig_dlp_integrations,
    aig_dlp_create_integration,
    aig_dlp_update_integration,
    aig_whitelist,
    aig_whitelist_add,
    aig_whitelist_remove,
    aig_exception_requests,
    aig_exception_create,
    aig_exception_review,
    aig_enforce_block,
    aig_enforcement_integrations,
    aig_enforcement_save,
    aig_enforcement_delete,
    aig_enforcement_test,
    aig_user_profiles,
    aig_blocklist_export,
    aig_blocklist_formats,
    aig_audit_log,
    aig_schedules,
    aig_schedule_create,
    aig_schedule_toggle,
    aig_schedule_delete,
    aig_export_assets,
    aig_aibom_export,
    // Internal Audit
    aig_audit_dashboard,
    aig_audit_my_tasks,
    aig_audit_frameworks,
    aig_audit_create_framework,
    aig_audit_delete_framework,
    aig_audit_update_framework,
    aig_audit_framework_controls,
    aig_audit_download_template,
    aig_audit_preview_headers,
    aig_audit_upload_controls,
    aig_audit_list,
    aig_audit_create,
    aig_audit_detail,
    aig_audit_questions,
    aig_audit_auditee_progress,
    aig_audit_respond,
    aig_audit_review,
    aig_audit_review_bulk,
    aig_audit_findings,
    aig_audit_create_finding,
    aig_audit_policies,
    aig_audit_create_policy,
    aig_audit_submit_policy,
    aig_audit_approve_policy,
    aig_audit_generate_report,
    aig_audit_issue_aging,
    aig_audit_evidence_request,
    aig_audit_evidence_upload,
    aig_audit_evidence_download,
    aig_audit_field_history,
    aig_audit_approval_status,
    aig_audit_approve_stage,
    aig_audit_evidence_requests,
    aig_audit_evidence_request_create,
    aig_audit_evidence_request_submit,
    aig_audit_evidence_request_review,
    aig_audit_management_response,
    aig_audit_verify_finding,
    aig_audit_universe,
    aig_audit_bulk_assess,
    aig_audit_submit_findings,
    aig_audit_notifications,

    // Audit — Business Units
    aig_audit_business_units,
    aig_audit_create_business_unit,
    aig_audit_update_business_unit,

    // Audit — Users
    aig_audit_users,
    aig_audit_invite_user,
    aig_audit_update_user,
    aig_audit_deactivate_user,

    // Audit — Projects
    aig_audit_projects,
    aig_portal_invite,
    aig_portal_register,
    aig_portal_login,
    aig_portal_users,
    aig_portal_session,
    aig_portal_user_update,
    aig_portal_user_delete,
    aig_audit_user_modules,
    aig_portal_ad_sync,
    aig_portal_ad_config,
    aig_workflow_config,
    aig_workflow_config_update,
    aig_workflow_config_apply_template,
    aig_workflow_config_reset,
    aig_audit_update_project,
    aig_audit_delete_project,
    aig_audit_create_project,

    // Audit Admin
    aig_audit_custom_fields,
    aig_audit_custom_field_create,
    aig_audit_custom_field_update,
    aig_audit_custom_field_delete,
    aig_audit_custom_field_reorder,
    aig_audit_custom_field_save_values,
    aig_audit_custom_field_values,
    aig_audit_workflows,
    aig_audit_create_workflow,
    aig_audit_update_workflow,
    aig_audit_delete_workflow,
    aig_audit_config,
    aig_audit_config_update,

    // Audit Lifecycle
    aig_audit_update,
    aig_audit_assign,
    aig_audit_advance_stage,
    aig_audit_progress,
    aig_audit_timeline,
    aig_audit_close,
    aig_audit_delete,
    aig_audit_complete,
    aig_audit_sign_off,
    aig_audit_bulk_assign_questions,
    aig_audit_assign_controls,
    aig_audit_export_responses,

    // Finding Lifecycle
    aig_audit_update_finding,
    aig_audit_remediate_finding,
    aig_audit_accept_risk,
    aig_audit_create_risk_from_finding,

    // Evidence
    aig_audit_delete_evidence,

    // Policy Lifecycle
    aig_audit_update_policy,
    aig_audit_policy_versions,
    aig_audit_policy_acknowledge,
    aig_audit_policy_ack_status,

    // Internal Audit Enhancements
    aig_audit_clone,
    aig_audit_linked,
    aig_audit_recurring_schedules,
    aig_audit_create_recurring_schedule,
    aig_audit_update_recurring_schedule,
    aig_audit_delete_recurring_schedule,
    aig_audit_scope_tree,
    aig_audit_update_scope,
    aig_audit_add_framework,
    aig_audit_multi_frameworks,
    aig_audit_compare,
    aig_audit_capas,
    aig_audit_create_capa,
    aig_audit_update_capa,
    aig_audit_delete_capa,
    aig_audit_capa_history,
    aig_audit_bulk_update_capas,
    aig_audit_capa_export,
    aig_audit_management_summary,
    aig_audit_evidence_library,
    aig_audit_evidence_library_filters,
    aig_audit_evidence_library_export,
    aig_audit_evidence_library_audits,
    aig_audit_evidence_library_breakdown,
    aig_audit_check_recurring_finding,
    aig_audit_set_scoring_model,
    aig_audit_set_maturity_score,
    aig_audit_calendar,
    aig_audit_create_calendar_entry,
    aig_audit_update_calendar_entry,
    aig_audit_delete_calendar_entry,
    aig_audit_convert_calendar_entry,
    aig_audit_export_calendar,

    // KRI Matrix
    user_modules,
    kpi_preview,
    kpi_import,
    kpi_acknowledge,
    kpi_update,
    kpi_upload_evidence,
    kpi_my_kpis,
    kpi_template,
    kpi_library,
    kpi_library_import,
    kpis_list,
    kpis_create,
    kpis_update,
    kpis_delete,
    kpis_acknowledge,
    kpis_evidence,
    kpis_history,
    kpis_bulk_update,
    kpi_snapshot,
    kpi_trends,
    kpis_purge,
    kpis_bulk_archive,
    kpis_archive_batches,
    kpis_bulk_purge,
    kpis_updates_list,
    kpis_updates_create,
    kpi_admins_list,
    kpi_admins_revoke,
    kpi_org_config_get,
    kpi_org_config_update,
    kpis_assign_owner,
    kpis_bulk_assign,
    kpis_escalations,
    kpis_escalations_send,
    kpis_escalate,
    kpis_export,
    kpis_dedupe,
    kpis_restore,
    kpis_ai_summarise_quarter,
    kpis_ai_explain_gap,
    kpis_evidence_list,
    kpis_evidence_delete,
    kpis_evidence_download,
    kri_dashboard,
    kri_tools,
    kri_vendors,
    kri_create_tool,
    kri_update_tool,
    kri_delete_tool,
    kri_test_tool,
    kri_preview_tool,
    kri_sync_tool,
    kri_upload_tool_devices,
    kri_assets,
    kri_create_asset,
    kri_upload_assets,
    kri_delete_asset,
    kri_matrix,
    kri_gaps,
    kri_remediate_gap,
    kri_sync_logs,
    kri_export_gaps,
    kri_connector_discover,
    kri_connector_ai_map,
    kri_get_upload_checklist,
    kri_get_sync_status,
    kri_reprocess_tool,
    kri_list_unmatched_tool_assets,
    kri_add_unmatched_to_baseline,
    kri_dismiss_unmatched_tool_asset,
    kri_list_definitions,
    kri_create_definition,
    kri_update_definition,
    kri_delete_definition,
    kri_permanent_delete_definition,
    kri_download_definition_template,
    kri_import_definitions_preview,
    kri_import_definitions_commit,
    kri_request_baseline_recommendation,
    kri_apply_baseline_to_tool,
    kri_ai_auto_configure_from_preview,
    kri_ai_diagnose_connection_failure,
    kri_ai_suggest_adapter,
    kri_ai_explain_upload,
    kri_ai_suggest_dashboard_labels,
    kri_ai_summarise_dashboard,
    kri_ai_analyze_coverage,
    kri_ai_analyze_gaps,
    kri_ai_audit_baseline,
    kri_ai_suggest_api_url,
    kri_get_tool_usage_metrics,
    kri_get_tool_drift_history,
    kri_get_baseline_policies,
    kri_list_tools,
    kri_list_vendors,
    kri_list_gaps,
    kri_list_assets,
    kri_list_sync_logs,
    kri_mark_gap_remediated,
    kri_get_dashboard,
    kri_get_compliance_matrix,
    kri_test_tool_connection,
    kri_preview_tool_data,
    kri_preview_tool_status,
    kri_universal_discover_fields,
    kri_ai_map_universal_fields,
    kri_export_gap_report,
    kri_cancel_sync,
    kri_get_org_settings,
    kri_update_org_settings,
    kri_list_mapping_rules,
    kri_create_mapping_rule,
    kri_update_mapping_rule,
    kri_delete_mapping_rule,
    kri_apply_mapping_rule,
    kri_save_snapshot,
    kri_set_tool_rollout_grace,
    kri_get_tool_audit_log,

    // Endpoint Config
    sbom_wazuh_config_get,
    sbom_wazuh_config_save,
    sbom_wazuh_config_test,
    sbom_wazuh_config_disable,
    sbom_wazuh_config_delete,

    // Ops Search
    ops_search,
    ops_assets,

    // Trust Center
    tc_get_config,
    tc_setup,
    tc_publish,
    tc_list_pages,
    tc_update_page,
    tc_list_certifications,
    tc_create_certification,
    tc_list_sub_processors,
    tc_create_sub_processor,
    tc_init_practices,
    tc_list_access_requests,
    tc_approve_request,
    tc_reject_request,
    tc_analytics,
    tc_notif_config,
    tc_notif_update,
    tc_notif_test,

    //Complaince Ready
    assign_organization_compliance_form,
    check_compliance_available_for_framework,
    domain_selection_list,
    assign_organization_domain_owner,
    user_assign_domains_question_list,
    check_with_nova,
    upload_document_to_check_with_nova,
    submit_framework_question_answer,
    scan_alert_risk_data,
    alert_chat,
    alert_chat_initialize,
    get_questionnaires,
    get_fields_measures_metadata,
    upsert_fields_measures_metadata,
    delete_fields_measures_metadata,
    populateAwsDataService,
    populateAzureDataService,
    populateGcpDataService,
    populateOnpremDataService,
    addCloudAccountService,
    getCloudOrgScoreService,
    getCloudAccountsOverviewService,
    editCloudAccountService,
    rescanCloudAccountService,
    getCloudServiceDetailsService,

    // Risk Portal
    risk_portal_dashboard,
    risk_portal_heatmap,
    risk_portal_risks,
    risk_portal_risk_detail,
    risk_portal_assess,
    risk_portal_create_treatment,
    risk_portal_update_treatment,
    risk_portal_kri_list,
    risk_portal_create_kri,
    risk_portal_add_control,
    risk_portal_categories,
    risk_portal_create_category,
    risk_portal_appetite,
    risk_portal_save_appetite,
    risk_portal_workflow_config,
    risk_portal_update_workflow,
    risk_portal_users,
    risk_portal_invite,
    risk_portal_login,
    risk_portal_register,
    risk_portal_add_comment,
    risk_portal_upload_evidence,
    risk_portal_activity,
    risk_portal_approve_treatment,
    risk_portal_reject_treatment,
    risk_portal_overdue_treatments,
    risk_portal_update_kri,
    risk_portal_delete_kri,
    risk_portal_framework_controls,
    risk_portal_framework_list,
    risk_portal_update_control,
    risk_portal_delete_control,
    risk_portal_appetite_breaches,
    risk_portal_velocity_summary,
    risk_portal_delete_treatment,
    risk_portal_delete_category,
    risk_portal_delete_appetite,
    risk_portal_delete_evidence,
    risk_portal_download_evidence,
    risk_portal_delete_comment,
    risk_portal_pending_treatments,
    risk_portal_workflow_state,
    risk_portal_advance_stage,
    risk_portal_accept_risk,
    risk_portal_close_risk,
    risk_portal_seed_defaults,
    risk_portal_bulk_import,
    risk_portal_share_risk,
    risk_portal_list_shares,
    risk_portal_revoke_share,
    risk_portal_public_view,
    risk_portal_public_update,
    risk_portal_public_acknowledge,
    risk_portal_request_ack,
    risk_portal_get_ack,
    risk_portal_get_quantification,
    risk_portal_save_quantification,
    risk_portal_monte_carlo,
    risk_portal_get_bowtie,
    risk_portal_save_bowtie,
    risk_portal_list_scenarios,
    risk_portal_create_scenario,
    risk_portal_get_scenario,
    risk_portal_delete_scenario,
    risk_portal_list_review_schedules,
    risk_portal_create_review_schedule,
    risk_portal_delete_review_schedule,
    risk_portal_ai_categorize,
    risk_portal_ai_duplicates,
    risk_portal_ai_risk_statement,
    risk_portal_ai_suggest_treatment,
    risk_portal_board_report,
    aig_audit_capa_assignable_users,
    aig_audit_capa_findings,
    // Roles / RBAC
    risk_portal_update_user_role,
    risk_portal_roles_list,
    risk_portal_role_create,
    risk_portal_role_update,
    risk_portal_role_delete,
    risk_portal_role_resend_invite,
    risk_portal_roles_audit_log,
    // Business Units
    risk_portal_bus_list,
    risk_portal_bu_tree,
    risk_portal_bu_create,
    risk_portal_bu_update,
    risk_portal_bu_delete,
    risk_portal_bu_breakdown,
    // Settings / Customisation
    risk_portal_get_settings,
    risk_portal_update_settings,
    // Projects
    risk_portal_projects_list,
    risk_portal_project_create,
    risk_portal_project_update,
    risk_portal_project_delete,
    risk_portal_project_breakdown,
    risk_portal_portfolio_trend,
    // Audit / SLA / Bulk
    risk_portal_field_changes,
    risk_portal_sla_escalations,
    risk_portal_dispatch_escalations,
    risk_portal_bulk_template,
    // Compliance Coverage
    risk_portal_compliance_mappings,
    risk_portal_map_compliance,
    risk_portal_delete_compliance_mapping,
    risk_portal_compliance_coverage,
    risk_portal_ensure_admin,

    // ai governance 
    ai_dashboard,
    ai_detection_sources,
    ai_load_ai_categories,
    ai_options,
    ai_org_users,
    ai_recompute,
    ai_user_profiles,
    ai_v2_load_dashboard_summary,
    audit_log,

    // Saved searches
    ai_saved_search_create,
    ai_saved_search_delete,
    ai_saved_search_run,
    ai_saved_searches,

    // Policies
    ai_generate_policy,
    ai_policies,
    ai_policy_create,
    ai_policy_delete,
    ai_policy_dry_run,
    ai_policy_evaluate_all,
    ai_policy_gen_get,
    ai_policy_gen_list,
    ai_policy_gen_sign,
    ai_policy_init_defaults,
    ai_policy_instantiate_library,
    ai_policy_suggest_refs,
    ai_policy_suggest_refs_bulk,
    ai_policy_toggle,
    ai_policy_update,
    ai_v2_bulk_activate_policies,
    ai_v2_bulk_transition_policies,
    ai_v2_load_policies,
    ai_v2_load_policy_scores_ranked,
    ai_v2_transition_policy_mode,

    // Policy bindings (v2)
    ai_v2_bindings_matrix,
    ai_v2_endpoint_bindings_matrix,
    ai_v2_policy_binding_create,
    ai_v2_policy_binding_delete,
    ai_v2_policy_binding_transition,
    ai_v2_policy_endpoint_binding_create,
    ai_v2_policy_endpoint_binding_delete,
    ai_v2_policy_endpoint_binding_transition,

    // Frameworks
    ai_framework_clone,
    ai_framework_control_create,
    ai_framework_create,
    ai_framework_delete,
    ai_framework_detail,
    ai_framework_update,
    ai_frameworks,
    ai_v2_activate_framework_recommendation,
    ai_v2_ai_generate_framework_recommendation,
    ai_v2_get_framework,
    ai_v2_load_framework_catalog,
    ai_v2_load_framework_scores_heatmap,

    // Compliance, risk & controls
    ai_assess_all,
    ai_compliance_evaluate,
    ai_compliance_scores,
    ai_control_delete,
    ai_control_evidence,
    ai_control_evidence_upload,
    ai_control_update,
    ai_evaluator_catalog,
    ai_risk_scores,

    // Evidence & auditor tokens
    ai_v2_fetch_evidence_payload,
    ai_v2_issue_auditor_token,
    ai_v2_load_auditor_tokens,
    ai_v2_load_evidence,
    ai_v2_revoke_auditor_token,
    ai_v2_verify_evidence,

    // Inventory, assets & scanning
    ai_approve_asset,
    ai_assets,
    ai_block_asset,
    ai_scan,
    ai_unblock_asset,

    // Signatures
    ai_load_default_signatures,
    ai_signature_create,
    ai_signature_delete,
    ai_signature_update,
    ai_signatures,
    ai_signatures_accept,
    ai_signatures_bulk_import,
    ai_signatures_expand,
    ai_signatures_review,
    ai_signatures_suggested,

    // DLP
    ai_dlp_anomalies,
    ai_dlp_create_integration,
    ai_dlp_event_patterns,
    ai_dlp_events,
    ai_dlp_integrations,
    ai_dlp_poll_all,
    ai_dlp_poll_integration,
    ai_dlp_summary,
    ai_dlp_toggle_integration,
    ai_dlp_update_integration,
    loadDLPDashboard,

    // Incidents, violations & events
    ai_event_assign,
    ai_event_comment_add,
    ai_event_comments_get,
    ai_event_set_status,
    ai_violation_update_status,
    ai_violations,
    ai_violations_bulk_status,

    // Response evaluation & sentiment
    ai_v2_get_response_eval,
    ai_v2_load_response_eval_summary,
    ai_v2_load_response_evals,
    ai_v2_load_sentiment_trends_anomalies,
    ai_v2_load_sentiment_trends_heatmap,

    // Red team & bias
    ai_bias_audit_create,
    ai_bias_audit_detail,
    ai_bias_audit_report_url,
    ai_bias_audits,
    ai_red_team_prompt_create,
    ai_red_team_prompt_delete,
    ai_red_team_prompts,
    ai_red_team_run_cancel,
    ai_red_team_run_detail,
    ai_red_team_run_report_url,
    ai_red_team_run_start,
    ai_red_team_runs,

    // DSAR (data subject requests)
    ai_dsar_audit_packet_url,
    ai_dsar_request_complete,
    ai_dsar_request_create,
    ai_dsar_request_detail,
    ai_dsar_requests,
    ai_dsar_task_execute,

    // Whitelist & blocklist
    ai_blocklist_export,
    ai_blocklist_formats,
    ai_whitelist,
    ai_whitelist_add,
    ai_whitelist_remove,

    // Schedules
    ai_schedule_create,
    ai_schedule_delete,
    ai_schedule_toggle,
    ai_schedules,

    // Groups, persons & identity links
    ai_approve_link_review,
    ai_group_create,
    ai_group_delete,
    ai_group_update,
    ai_groups,
    ai_groups_active_users,
    ai_load_cost_advisor_by_group,
    ai_load_link_reviews,
    ai_persons_merge,
    ai_reject_link_review,

    // IdP integrations (v2)
    ai_v2_create_idp_integration,
    ai_v2_delete_idp_integration,
    ai_v2_load_idp_integrations,
    ai_v2_sync_now_idp_integration,
    ai_v2_test_idp_integration,
    ai_v2_update_idp_integration,

    // Enforcement integrations
    ai_enforcement_delete,
    ai_enforcement_integrations,
    ai_enforcement_save,
    ai_enforcement_test,
    ai_integration_adapters,

    // Browser extension, fleet & MDM
    ai_claim_extension_device,
    ai_ext_config,
    ai_ext_config_update,
    ai_ext_fleet,
    ai_ext_push_config,
    ai_ext_regenerate_token,
    ai_ext_revoke,
    ai_ext_set_mode,
    ai_v2_ext_mdm_download_url,
    ai_v2_issue_ext_enrollment,
    ai_v2_load_ext_mdm_catalog,

    // LLM Gateway (v2)
    ai_v2_bulk_issue_gateway_keys,
    ai_v2_create_gateway_key,
    ai_v2_delete_gateway_budget,
    ai_v2_delete_gateway_vendor_cred,
    ai_v2_load_gateway_budget,
    ai_v2_load_gateway_budget_alerts,
    ai_v2_load_gateway_keys,
    ai_v2_load_gateway_recent,
    ai_v2_load_gateway_usage,
    ai_v2_load_gateway_vendor_creds,
    ai_v2_revoke_gateway_key,
    ai_v2_send_gateway_budget_report,
    ai_v2_test_gateway_budget_alert,
    ai_v2_upsert_gateway_budget,
    ai_v2_upsert_gateway_budget_alerts,
    ai_v2_upsert_gateway_vendor_cred,

    // Cost advisor & budget
    ai_delete_cost_advisor_config,
    ai_load_cost_advisor_config,
    ai_load_cost_advisor_top_spenders,
    ai_upsert_cost_advisor_config,
    ai_v2_load_budget_breakdown,
    ai_v2_load_cost_advisor,

    // Vendor coverage
    ai_bulk_seed_vendor_members,
    ai_cancel_vendor_enrollment,
    ai_create_vendor_enrollment,
    ai_list_vendor_enrollment,
    ai_list_vendor_profiles,
    ai_load_vendor_coverage,
    ai_load_vendor_coverage_config,
    ai_save_vendor_coverage_config,
    ai_sweep_vendor_enrollment,
    ai_v2_load_coverage_posture,

    // Severity tuning
    ai_sev_apply_preset,
    ai_sev_override_delete,
    ai_sev_override_set,
    ai_sev_overrides,
    ai_sev_presets,
    ai_sev_topics,

    // SIEM forwarders
    ai_siem_forwarder_create,
    ai_siem_forwarder_delete,
    ai_siem_forwarder_test,
    ai_siem_forwarder_toggle,
    ai_siem_forwarders,

    // Tenant nodes & org profiles (v2)
    ai_v2_ai_create_org_profile,
    ai_v2_load_org_profiles,
    ai_v2_load_tenant_nodes,
    ai_v2_load_tenant_nodes_diagnostic,
    ai_v2_seed_tenant_root,

    // Agent traces
    ai_load_agent_trace_detail,
    ai_load_agent_trace_summary,
    ai_load_agent_traces,

    // SSO Authentication (super-admin)
    get_sso_domains,
    add_sso_domain,
    verify_sso_domain_manually,
    get_sso_connections,
    create_sso_connection,
    create_support_request,
    update_sso_connection,
    delete_sso_connection,
}